const salary = [
  {
    anaheim_ducks: [
      {
        player: "John Carlson",
        salary2025: "$8,000,000",
      },

      {
        player: "Mason McTavish",
        salary2025: "$7,000,000",
      },
      {
        player: "Troy Terry",
        salary2025: "$7,000,000",
      },
      {
        player: "Mikael Granlund",
        salary2025: "$7,000,000",
      },
      {
        player: "Chris Kreider",
        salary2025: "$6,500,000",
      },
      {
        player: "Alex Killorn",
        salary2025: "$6,250,000",
      },
      {
        player: "Frank Vatrano",
        salary2025: "$4,571,189",
      },
      {
        player: "Ryan Poehling",
        salary2025: "$1,900,000",
      },
      {
        player: "Ross Johnston",
        salary2025: "$1,100,000",
      },
      {
        player: "Cutter Gauthier",
        salary2025: "$950,000",
      },
      {
        player: "Leo Carlsson",
        salary2025: "$950,000",
      },
      {
        player: "Beckett Sennecke",
        salary2025: "$942,500",
      },
      {
        player: "Sam Colangelo",
        salary2025: "$850,000",
      },
      {
        player: "Tim Washe",
        salary2025: "$812,500",
      },
      {
        player: "Jansen Harkins",
        salary2025: "$787,500",
      },
      {
        player: "Jeffrey Viel",
        salary2025: "$775,000",
      },
      {
        player: "Jacob Trouba",
        salary2025: "$8,000,000",
      },
      {
        player: "Radko Gudas",
        salary2025: "$4,000,000",
      },
      {
        player: "Drew Helleson",
        salary2025: "$1,100,000",
      },
      {
        player: "Jackson LaCombe",
        salary2025: "$925,000",
      },
      {
        player: "Ian Moore",
        salary2025: "$925,000",
      },
      {
        player: "Pavel Mintyukov",
        salary2025: "$918,333",
      },
      {
        player: "Olen Zellweger",
        salary2025: "$844,167",
      },
      {
        player: "Lukas Dostal",
        salary2025: "$6,500,000",
      },
      {
        player: "Petr Mrazek",
        salary2025: "$4,250,000",
      },
      {
        player: "Ville Husso",
        salary2025: "$2,200,000",
      },
      {
        player: "Cam Fowler",
        salary2025: "$2,500,000",
      },
      {
        player: "Nico Myatovic",
        salary2025: "$896,667",
      },
      {
        player: "Nathan Gaucher",
        salary2025: "$886,667",
      },
      {
        player: "Lucas Pettersson",
        salary2025: "$869,050",
      },
      {
        player: "Yegor Sidorov",
        salary2025: "$865,000",
      },
      {
        player: "Coulson Pitre",
        salary2025: "$860,000",
      },
      {
        player: "Jaxsen Wiebe",
        salary2025: "$852,500",
      },
      {
        player: "Sasha Pastujov",
        salary2025: "$825,000",
      },
      {
        player: "Nikita Nesterenko",
        salary2025: "$787,500",
      },
      {
        player: "Jan Mysak",
        salary2025: "$775,000",
      },
      {
        player: "Stian Solberg",
        salary2025: "$942,500",
      },
      {
        player: "Noah Warren",
        salary2025: "$865,000",
      },
      {
        player: "Tristan Luneau",
        salary2025: "$865,000",
      },
      {
        player: "Konnor Smith",
        salary2025: "$855,000",
      },
      {
        player: "Tyson Hinds",
        salary2025: "$829,444",
      },
      {
        player: "Jeremie Biakabutuka",
        salary2025: "$825,000",
      },
      {
        player: "Tomas Suchanek",
        salary2025: "$870,000",
      },
      {
        player: "Vyacheslav Buteyets",
        salary2025: "$852,500",
      },
      {
        player: "Damian Clara",
        salary2025: "$846,667",
      },
      {
        player: "Calle Clang",
        salary2025: "$775,000",
      },
    ],
  },
  {
    boston_bruins: [
      {
        player: "David Pastrnak",
        salary2025: "$11,250,000",
      },
      {
        player: "Elias Lindholm",
        salary2025: "$7,750,000",
      },
      {
        player: "Casey Mittelstadt",
        salary2025: "$5,750,000",
      },
      {
        player: "Morgan Geekie",
        salary2025: "$5,500,000",
      },
      {
        player: "Pavel Zacha",
        salary2025: "$4,750,000",
      },
      {
        player: "Viktor Arvidsson",
        salary2025: "$4,000,000",
      },
      {
        player: "Tanner Jeannot",
        salary2025: "$3,400,000",
      },
      {
        player: "Sean Kuraly",
        salary2025: "$1,850,000",
      },
      {
        player: "Mark Kastelic",
        salary2025: "$1,566,667",
      },
      {
        player: "Michael Eyssimont",
        salary2025: "$1,450,000",
      },
      {
        player: "Marat Khusnutdinov",
        salary2025: "$925,000",
      },
      {
        player: "Alex Steeves",
        salary2025: "$850,000",
      },
      {
        player: "Fraser Minten",
        salary2025: "$816,667",
      },
      {
        player: "Charlie McAvoy",
        salary2025: "$9,500,000",
      },
      {
        player: "Hampus Lindholm",
        salary2025: "$6,500,000",
      },
      {
        player: "Nikita Zadorov",
        salary2025: "$5,000,000",
      },
      {
        player: "Mason Lohrei",
        salary2025: "$3,200,000",
      },
      {
        player: "Henri Jokiharju",
        salary2025: "$3,000,000",
      },
      {
        player: "Andrew Peeke",
        salary2025: "$2,750,000",
      },
      {
        player: "Jonathan Aspirot",
        salary2025: "$775,000",
      },
      {
        player: "Vladislav Kolyachonok",
        salary2025: "$775,000",
      },
      {
        player: "Billy Sweezey",
        salary2025: "$775,000",
      },
      {
        player: "Jeremy Swayman",
        salary2025: "$8,250,000",
      },
      {
        player: "Joonas Korpisalo",
        salary2025: "$3,000,000",
      },
      {
        player: "Jordan Harris",
        salary2025: "$825,000",
      },
      {
        player: "Brandon Carlo",
        salary2025: "$615,000",
      },
      {
        player: "Dalton Bancroft",
        salary2025: "$950,000",
      },
      {
        player: "Matej Blumel",
        salary2025: "$875,000",
      },
      {
        player: "Matthew Poitras",
        salary2025: "$870,000",
      },
      {
        player: "Riley Duran",
        salary2025: "$867,500",
      },
      {
        player: "Fabian Lysell",
        salary2025: "$863,333",
      },
      {
        player: "Dans Locmelis",
        salary2025: "$860,000",
      },
      {
        player: "Brett Harrison",
        salary2025: "$836,667",
      },
      {
        player: "John Farinacci",
        salary2025: "$775,000",
      },
      {
        player: "Patrick Brown",
        salary2025: "$775,000",
      },
      {
        player: "Georgii Merkulov",
        salary2025: "$775,000",
      },
      {
        player: "Riley Tufte",
        salary2025: "$775,000",
      },
      {
        player: "Frederic Brunet",
        salary2025: "$860,000",
      },
      {
        player: "Jackson Edward",
        salary2025: "$831,667",
      },
      {
        player: "Loke Johansson",
        salary2025: "$831,667",
      },
      {
        player: "Maximus Wanner",
        salary2025: "$828,333",
      },
      {
        player: "Victor Soderstrom",
        salary2025: "$775,000",
      },
      {
        player: "Michael Callahan",
        salary2025: "$775,000",
      },
      {
        player: "Simon Zajicek",
        salary2025: "$872,500",
      },
      {
        player: "Michael DiPietro",
        salary2025: "$812,500",
      },
      {
        player: "Luke Cavallin",
        salary2025: "$790,000",
      },
    ],
  },
  {
    buffalo_sabres: [
      {
        player: "Josh Norris",
        salary2025: "$7,950,000",
      },
      {
        player: "Tage Thompson",
        salary2025: "$7,142,857",
      },
      {
        player: "Ryan McLeod",
        salary2025: "$5,000,000",
      },
      {
        player: "Alex Tuch",
        salary2025: "$4,750,000",
      },
      {
        player: "Jason Zucker",
        salary2025: "$4,750,000",
      },
      {
        player: "Jordan Greenway",
        salary2025: "$4,000,000",
      },
      {
        player: "Jack Quinn",
        salary2025: "$3,375,000",
      },
      {
        player: "Justin Danforth",
        salary2025: "$1,800,000",
      },
      {
        player: "Peyton Krebs",
        salary2025: "$1,450,000",
      },
      {
        player: "Beck Malenstyn",
        salary2025: "$1,350,000",
      },
      {
        player: "Zach Benson",
        salary2025: "$950,000",
      },
      {
        player: "Konsta Helenius",
        salary2025: "$942,500",
      },
      {
        player: "Josh Doan",
        salary2025: "$925,000",
      },
      {
        player: "Jiri Kulich",
        salary2025: "$886,667",
      },
      {
        player: "Noah Ostlund",
        salary2025: "$886,667",
      },
      {
        player: "Josh Dunne",
        salary2025: "$775,000",
      },
      {
        player: "Tyson Kozak",
        salary2025: "$750,000",
      },
      {
        player: "Rasmus Dahlin",
        salary2025: "$11,000,000",
      },
      {
        player: "Owen Power",
        salary2025: "$8,350,000",
      },
      {
        player: "Bowen Byram",
        salary2025: "$6,250,000",
      },
      {
        player: "Mattias Samuelsson",
        salary2025: "$4,285,714",
      },
      {
        player: "Conor Timmins",
        salary2025: "$2,200,000",
      },
      {
        player: "Michael Kesselring",
        salary2025: "$1,400,000",
      },
      {
        player: "Zach Metsa",
        salary2025: "$775,000",
      },
      {
        player: "Ukko-Pekka Luukkonen",
        salary2025: "$4,750,000",
      },
      {
        player: "Alex Lyon",
        salary2025: "$1,500,000",
      },
      {
        player: "Colten Ellis",
        salary2025: "$775,000",
      },
      {
        player: "Jeff Skinner",
        salary2025: "$4,444,444",
      },
      {
        player: "Tyler Kopff",
        salary2025: "$975,000",
      },
      {
        player: "Isak Rosen",
        salary2025: "$894,167",
      },
      {
        player: "Viktor Neuchev",
        salary2025: "$870,000",
      },
      {
        player: "Riley Fiddler-Schultz",
        salary2025: "$865,000",
      },
      {
        player: "Olivier Nadeau",
        salary2025: "$836,667",
      },
      {
        player: "Anton Wahlberg",
        salary2025: "$833,333",
      },
      {
        player: "Jake Leschyshyn",
        salary2025: "$775,000",
      },
      {
        player: "Carson Meyer",
        salary2025: "$775,000",
      },
      {
        player: "Mason Geertsen",
        salary2025: "$775,000",
      },
      {
        player: "Trevor Kuntar",
        salary2025: "$775,000",
      },
      {
        player: "Radim Mrtka",
        salary2025: "$975,000",
      },
      {
        player: "Zac Jones",
        salary2025: "$900,000",
      },
      {
        player: "Isaac Belliveau",
        salary2025: "$875,000",
      },
      {
        player: "Nikita Novikov",
        salary2025: "$867,500",
      },
      {
        player: "Vsevolod Komarov",
        salary2025: "$835,000",
      },
      {
        player: "Jack Rathbone",
        salary2025: "$800,000",
      },
      {
        player: "Ryan Johnson",
        salary2025: "$775,000",
      },
      {
        player: "Topias Leinonen",
        salary2025: "$886,667",
      },
      {
        player: "Scott Ratzlaff",
        salary2025: "$835,000",
      },
      {
        player: "Devon Levi",
        salary2025: "$812,500",
      },
    ],
  },
  {
    calgary_flames: [
      {
        player: "Zach Whitecloud",
        salary2025: "$2,750,000",
      },

      {
        player: "Olli Maatta",
        salary2025: "$3,500,000",
      },

      {
        player: "Victor Olofsson",
        salary2025: "$1,575,000",
      },

      {
        player: "Ryan Strome",
        salary2025: "$5,000,000",
      },

      {
        player: "Jonathan Huberdeau",
        salary2025: "$10,500,000",
      },
      {
        player: "Matt Coronato",
        salary2025: "$6,500,000",
      },
      {
        player: "Yegor Sharangovich",
        salary2025: "$5,750,000",
      },
      {
        player: "Joel Farabee",
        salary2025: "$5,000,000",
      },
      {
        player: "Blake Coleman",
        salary2025: "$4,900,000",
      },
      {
        player: "Mikael Backlund",
        salary2025: "$4,500,000",
      },
      {
        player: "Morgan Frost",
        salary2025: "$4,375,000",
      },
      {
        player: "Connor Zary",
        salary2025: "$3,775,000",
      },
      {
        player: "Ryan Lomberg",
        salary2025: "$2,000,000",
      },
      {
        player: "Adam Klapka",
        salary2025: "$1,250,000",
      },
      {
        player: "William Stromgren",
        salary2025: "$900,833",
      },
      {
        player: "John Beecher",
        salary2025: "$900,000",
      },
      {
        player: "Justin Kirkland",
        salary2025: "$900,000",
      },
      {
        player: "Samuel Honzek",
        salary2025: "$886,667",
      },
      {
        player: "Dryden Hunt",
        salary2025: "$825,000",
      },
      {
        player: "Kevin Bahl",
        salary2025: "$5,350,000",
      },
      {
        player: "Rasmus Andersson",
        salary2025: "$4,550,000",
      },
      {
        player: "Jake Bean",
        salary2025: "$1,750,000",
      },
      {
        player: "Joel Hanley",
        salary2025: "$1,750,000",
      },
      {
        player: "Brayden Pachal",
        salary2025: "$1,187,500",
      },
      {
        player: "Hunter Brzustewicz",
        salary2025: "$950,000",
      },
      {
        player: "Zayne Parekh",
        salary2025: "$942,500",
      },
      {
        player: "Yan Kuznetsov",
        salary2025: "$812,500",
      },
      {
        player: "Dustin Wolf",
        salary2025: "$850,000",
      },
      {
        player: "Devin Cooley",
        salary2025: "$775,000",
      },
      {
        player: "Jacob Markstrom",
        salary2025: "$1,875,000",
      },
      {
        player: "Daniil Miromanov",
        salary2025: "$100,000",
      },
      {
        player: "Martin Pospisil",
        salary2025: "$1,000,000",
      },
      {
        player: "Matvei Gridin",
        salary2025: "$942,500",
      },
      {
        player: "Jacob Battaglia",
        salary2025: "$931,667",
      },
      {
        player: "Aydar Suniev",
        salary2025: "$923,333",
      },
      {
        player: "Carter King",
        salary2025: "$872,500",
      },
      {
        player: "Andrew Basha",
        salary2025: "$865,000",
      },
      {
        player: "Parker Bell",
        salary2025: "$857,500",
      },
      {
        player: "Lucas Ciona",
        salary2025: "$830,000",
      },
      {
        player: "Clark Bishop",
        salary2025: "$775,000",
      },
      {
        player: "Rory Kerins",
        salary2025: "$775,000",
      },
      {
        player: "Sam Morton",
        salary2025: "$775,000",
      },
      {
        player: "Etienne Morin",
        salary2025: "$871,667",
      },
      {
        player: "Artem Grushnikov",
        salary2025: "$814,167",
      },
      {
        player: "Nick Cicek",
        salary2025: "$775,000",
      },
      {
        player: "Jeremie Poirier",
        salary2025: "$775,000",
      },
      {
        player: "Daniil Miromanov",
        salary2025: "$100,000",
      },
      {
        player: "Ivan Prosvetov",
        salary2025: "$950,000",
      },
      {
        player: "Owen Say",
        salary2025: "$872,500",
      },
      {
        player: "Arsenii Sergeev",
        salary2025: "$866,250",
      },
    ],
  },
  {
    carolina_hurricanes: [
      {
        player: "Nicolas Deslauriers",
        salary2025: "$1,750,000",
      },

      {
        player: "Sebastian Aho",
        salary2025: "$9,750,000",
      },
      {
        player: "Nikolaj Ehlers",
        salary2025: "$8,500,000",
      },
      {
        player: "Andrei Svechnikov",
        salary2025: "$7,750,000",
      },
      {
        player: "Seth Jarvis",
        salary2025: "$7,420,087",
      },
      {
        player: "Jesperi Kotkaniemi",
        salary2025: "$4,820,000",
      },
      {
        player: "Taylor Hall",
        salary2025: "$3,166,667",
      },
      {
        player: "Jordan Martinook",
        salary2025: "$3,050,000",
      },
      {
        player: "Jordan Staal",
        salary2025: "$2,900,000",
      },
      {
        player: "William Carrier",
        salary2025: "$2,000,000",
      },
      {
        player: "Eric Robinson",
        salary2025: "$1,700,000",
      },
      {
        player: "Jackson Blake",
        salary2025: "$905,833",
      },
      {
        player: "Logan Stankoven",
        salary2025: "$814,167",
      },
      {
        player: "Mark Jankowski",
        salary2025: "$800,000",
      },
      {
        player: "Noah Philp",
        salary2025: "$775,000",
      },
      {
        player: "K'Andre Miller",
        salary2025: "$7,500,000",
      },
      {
        player: "Jaccob Slavin",
        salary2025: "$6,395,955",
      },
      {
        player: "Sean Walker",
        salary2025: "$3,600,000",
      },
      {
        player: "Shayne Gostisbehere",
        salary2025: "$3,200,000",
      },
      {
        player: "Jalen Chatfield",
        salary2025: "$3,000,000",
      },
      {
        player: "Mike Reilly",
        salary2025: "$1,100,000",
      },
      {
        player: "Alexander Nikishin",
        salary2025: "$925,000",
      },
      {
        player: "Joel Nystrom",
        salary2025: "$925,000",
      },
      {
        player: "Charles-Alexis Legault",
        salary2025: "$915,833",
      },
      {
        player: "Frederik Andersen",
        salary2025: "$2,750,000",
      },
      {
        player: "Pyotr Kochetkov",
        salary2025: "$2,000,000",
      },
      {
        player: "Brandon Bussi",
        salary2025: "$775,000",
      },
      {
        player: "Juuso Valimaki",
        salary2025: "$850,000",
      },
      {
        player: "Ivan Ryabkin",
        salary2025: "$918,333",
      },
      {
        player: "Bradly Nadeau",
        salary2025: "$886,667",
      },
      {
        player: "Gleb Trikozov",
        salary2025: "$862,500",
      },
      {
        player: "Justin Robidas",
        salary2025: "$825,000",
      },
      {
        player: "Noel Gunler",
        salary2025: "$813,750",
      },
      {
        player: "Felix Unger Sorum",
        salary2025: "$803,333",
      },
      {
        player: "Skyler Brind'Amour",
        salary2025: "$775,000",
      },
      {
        player: "Josiah Slavin",
        salary2025: "$775,000",
      },
      {
        player: "Ryan Suzuki",
        salary2025: "$775,000",
      },
      {
        player: "Givani Smith",
        salary2025: "$775,000",
      },
      {
        player: "Juha Jaaska",
        salary2025: "$775,000",
      },
      {
        player: "Kyle Masters",
        salary2025: "$865,000",
      },
      {
        player: "Bryce Montgomery",
        salary2025: "$854,910",
      },
      {
        player: "Juuso Valimaki",
        salary2025: "$850,000",
      },
      {
        player: "Dominik Badinka",
        salary2025: "$838,283",
      },
      {
        player: "Ronan Seeley",
        salary2025: "$813,750",
      },
      {
        player: "Aleksi Heimosalmi",
        salary2025: "$805,833",
      },
      {
        player: "Domenick Fensore",
        salary2025: "$775,000",
      },
      {
        player: "Gavin Bayreuther",
        salary2025: "$775,000",
      },
      {
        player: "Ruslan Khazheev",
        salary2025: "$845,000",
      },
      {
        player: "Nikita Quapp",
        salary2025: "$775,000",
      },
      {
        player: "Amir Miftakhov",
        salary2025: "$775,000",
      },
      {
        player: "Cayden Primeau",
        salary2025: "$775,000",
      },
    ],
  },
  {
    chicago_blackhawks: [
      {
        player: "Andrew Mangiapane",
        salary2025: "$3,600,000",
      },
      {
        player: "Tyler Bertuzzi",
        salary2025: "$5,500,000",
      },
      {
        player: "Andre Burakovsky",
        salary2025: "$5,500,000",
      },
      {
        player: "Teuvo Teravainen",
        salary2025: "$5,400,000",
      },
      {
        player: "Jason Dickinson",
        salary2025: "$4,250,000",
      },
      {
        player: "Ilya Mikheyev",
        salary2025: "$4,037,500",
      },
      {
        player: "Ryan Donato",
        salary2025: "$4,000,000",
      },
      {
        player: "Sam Lafferty",
        salary2025: "$2,000,000",
      },
      {
        player: "Connor Bedard",
        salary2025: "$950,000",
      },
      {
        player: "Frank Nazar",
        salary2025: "$950,000",
      },
      {
        player: "Ryan Greene",
        salary2025: "$950,000",
      },
      {
        player: "Oliver Moore",
        salary2025: "$941,667",
      },
      {
        player: "Landon Slaggert",
        salary2025: "$900,000",
      },
      {
        player: "Nick Lardis",
        salary2025: "$865,000",
      },
      {
        player: "Shea Weber",
        salary2025: "$7,857,143",
      },
      {
        player: "Ryan Ellis",
        salary2025: "$6,250,000",
      },
      {
        player: "Alex Vlasic",
        salary2025: "$4,600,000",
      },
      {
        player: "Wyatt Kaiser",
        salary2025: "$1,700,000",
      },
      {
        player: "Matt Grzelcyk",
        salary2025: "$1,000,000",
      },
      {
        player: "Artyom Levshunov",
        salary2025: "$975,000",
      },
      {
        player: "Louis Crevier",
        salary2025: "$900,000",
      },
      {
        player: "Spencer Knight",
        salary2025: "$4,500,000",
      },
      {
        player: "Arvid Soderblom",
        salary2025: "$2,750,000",
      },
      {
        player: "Seth Jones",
        salary2025: "$2,500,000",
      },
      {
        player: "TJ Brodie",
        salary2025: "$3,233,333",
      },
      {
        player: "Anton Frondell",
        salary2025: "$975,000",
      },
      {
        player: "Marek Vanacker",
        salary2025: "$942,500",
      },
      {
        player: "Anthony (AJ) Spellacy",
        salary2025: "$906,667",
      },
      {
        player: "Paul Ludwinski",
        salary2025: "$900,000",
      },
      {
        player: "Aidan Thompson",
        salary2025: "$895,000",
      },
      {
        player: "Martin Misiak",
        salary2025: "$878,333",
      },
      {
        player: "Gavin Hayes",
        salary2025: "$865,000",
      },
      {
        player: "Dominic Toninato",
        salary2025: "$850,000",
      },
      {
        player: "Samuel Savoie",
        salary2025: "$846,667",
      },
      {
        player: "Joey Anderson",
        salary2025: "$800,000",
      },
      {
        player: "Sam Rinzel",
        salary2025: "$941,667",
      },
      {
        player: "Kevin Korchinski",
        salary2025: "$918,333",
      },
      {
        player: "Taige Harding",
        salary2025: "$880,000",
      },
      {
        player: "Ethan Del Mastro",
        salary2025: "$855,833",
      },
      {
        player: "Jake Furlong",
        salary2025: "$841,667",
      },
      {
        player: "Ryan Mast",
        salary2025: "$830,556",
      },
      {
        player: "Dmitry Kuzmin",
        salary2025: "$795,556",
      },
      {
        player: "Stanislav Berezhnoy",
        salary2025: "$975,000",
      },
      {
        player: "Drew Commesso",
        salary2025: "$925,000",
      },
    ],
  },
  {
    colorado_avalanche: [
      {
        player: "Nick Blankenburg",
        salary2025: "$775,000",
      },

      {
        player: "Brett Kulak",
        salary2025: "$2,750,000",
      },
      {
        player: "Nicolas Roy",
        salary2025: "$3,000,000",
      },

      {
        player: "Nazem Kadri",
        salary2025: "$7,000,000",
      },
      {
        player: "Nathan MacKinnon",
        salary2025: "$12,600,000",
      },
      {
        player: "Brock Nelson",
        salary2025: "$7,500,000",
      },
      {
        player: "Gabriel Landeskog",
        salary2025: "$7,000,000",
      },
      {
        player: "Martin Necas",
        salary2025: "$6,500,000",
      },
      {
        player: "Valeri Nichushkin",
        salary2025: "$6,125,000",
      },
      {
        player: "Artturi Lehkonen",
        salary2025: "$4,500,000",
      },
      {
        player: "Ross Colton",
        salary2025: "$4,000,000",
      },
      {
        player: "Jack Drury",
        salary2025: "$1,725,000",
      },
      {
        player: "Joel Kiviranta",
        salary2025: "$1,250,000",
      },
      {
        player: "Gavin Brindley",
        salary2025: "$950,000",
      },
      {
        player: "Zakhar Bardakov",
        salary2025: "$867,500",
      },
      {
        player: "Parker Kelly",
        salary2025: "$825,000",
      },
      {
        player: "Cale Makar",
        salary2025: "$9,000,000",
      },
      {
        player: "Devon Toews",
        salary2025: "$7,250,000",
      },
      {
        player: "Josh Manson",
        salary2025: "$4,500,000",
      },
      {
        player: "Sam Malinski",
        salary2025: "$1,400,000",
      },
      {
        player: "Brent Burns",
        salary2025: "$1,000,000",
      },
      {
        player: "Jacob MacDonald",
        salary2025: "$775,000",
      },
      {
        player: "Mackenzie Blackwood",
        salary2025: "$5,250,000",
      },
      {
        player: "Scott Wedgewood",
        salary2025: "$1,500,000",
      },
      {
        player: "Logan O'Connor",
        salary2025: "$2,500,000",
      },
      {
        player: "Taylor Makar",
        salary2025: "$925,000",
      },
      {
        player: "Chase Bradley",
        salary2025: "$872,500",
      },
      {
        player: "Cooper Gay",
        salary2025: "$872,500",
      },
      {
        player: "Ivan Ivan",
        salary2025: "$845,000",
      },
      {
        player: "Nikita Prishchepov",
        salary2025: "$806,667",
      },
      {
        player: "Matt Stienburg",
        salary2025: "$775,000",
      },
      {
        player: "Alex Barré-Boulet",
        salary2025: "$775,000",
      },
      {
        player: "Tye Felhaber",
        salary2025: "$775,000",
      },
      {
        player: "Danil Gushchin",
        salary2025: "$775,000",
      },
      {
        player: "Jason Polin",
        salary2025: "$775,000",
      },
      {
        player: "Tristen Nielsen",
        salary2025: "$775,000",
      },
      {
        player: "T.J. Tynan",
        salary2025: "$775,000",
      },
      {
        player: "Alex Gagne",
        salary2025: "$910,000",
      },
      {
        player: "Sean Behrens",
        salary2025: "$905,833",
      },
      {
        player: "Saige Weinstein",
        salary2025: "$783,333",
      },
      {
        player: "Keaton Middleton",
        salary2025: "$775,000",
      },
      {
        player: "Ronnie Attard",
        salary2025: "$775,000",
      },
      {
        player: "Wyatt Aamodt",
        salary2025: "$775,000",
      },
      {
        player: "Jack Ahcan",
        salary2025: "$775,000",
      },
      {
        player: "Ilya Nabokov",
        salary2025: "$975,000",
      },
      {
        player: "Isak Posch",
        salary2025: "$872,500",
      },
      {
        player: "Trent Miner",
        salary2025: "$775,000",
      },
    ],
  },
  {
    columbus_blue_jackets: [
      {
        player: "Conor Garland",
        salary2025: "$4,950,000",
      },

      {
        player: "Sean Monahan",
        salary2025: "$5,500,000",
      },
      {
        player: "Charlie Coyle",
        salary2025: "$5,250,000",
      },
      {
        player: "Mason Marchment",
        salary2025: "$4,500,000",
      },
      {
        player: "Dmitri Voronkov",
        salary2025: "$4,175,000",
      },
      {
        player: "Kirill Marchenko",
        salary2025: "$3,850,000",
      },
      {
        player: "Boone Jenner",
        salary2025: "$3,750,000",
      },
      {
        player: "Mathieu Olivier",
        salary2025: "$3,000,000",
      },
      {
        player: "Miles Wood",
        salary2025: "$2,500,000",
      },
      {
        player: "Cole Sillinger",
        salary2025: "$2,250,000",
      },
      {
        player: "Danton Heinen",
        salary2025: "$2,250,000",
      },
      {
        player: "Kent Johnson",
        salary2025: "$1,800,000",
      },
      {
        player: "Isac Lundestrom",
        salary2025: "$1,300,000",
      },
      {
        player: "Adam Fantilli",
        salary2025: "$950,000",
      },
      {
        player: "Zach Aston-Reese",
        salary2025: "$775,000",
      },
      {
        player: "Brendan Gaunce",
        salary2025: "$775,000",
      },
      {
        player: "Mikael Pyyhtia",
        salary2025: "$775,000",
      },
      {
        player: "Zach Werenski",
        salary2025: "$9,583,333",
      },
      {
        player: "Ivan Provorov",
        salary2025: "$8,500,000",
      },
      {
        player: "Damon Severson",
        salary2025: "$6,250,000",
      },
      {
        player: "Dante Fabbro",
        salary2025: "$4,125,000",
      },
      {
        player: "Erik Gudbranson",
        salary2025: "$4,000,000",
      },
      {
        player: "Egor Zamula",
        salary2025: "$1,000,000",
      },
      {
        player: "Jake Christiansen",
        salary2025: "$975,000",
      },
      {
        player: "Denton Mateychuk",
        salary2025: "$886,667",
      },
      {
        player: "Luca Marrelli",
        salary2025: "$839,167",
      },
      {
        player: "Brendan Smith",
        salary2025: "$800,000",
      },
      {
        player: "Elvis Merzlikins",
        salary2025: "$5,400,000",
      },
      {
        player: "Jet Greaves",
        salary2025: "$812,500",
      },
      {
        player: "Alexander Wennberg",
        salary2025: "$891,667",
      },
      {
        player: "Adam Boqvist",
        salary2025: "$533,334",
      },
      {
        player: "Ivan Fedotov",
        salary2025: "$2,125,000",
      },
      {
        player: "Jack Williams",
        salary2025: "$923,750",
      },
      {
        player: "Oiva Keskinen",
        salary2025: "$860,000",
      },
      {
        player: "Jordan Dumais",
        salary2025: "$860,000",
      },
      {
        player: "Luca Del Bel Belluz",
        salary2025: "$860,000",
      },
      {
        player: "Max McCue",
        salary2025: "$858,333",
      },
      {
        player: "Luca Pinelli",
        salary2025: "$846,667",
      },
      {
        player: "James Malatesta",
        salary2025: "$841,667",
      },
      {
        player: "Hunter McKown",
        salary2025: "$800,000",
      },
      {
        player: "Owen Sillinger",
        salary2025: "$775,000",
      },
      {
        player: "Hudson Fasching",
        salary2025: "$775,000",
      },
      {
        player: "Corson Ceulemans",
        salary2025: "$925,000",
      },
      {
        player: "Caleb MacDonald",
        salary2025: "$922,500",
      },
      {
        player: "Charlie Elick",
        salary2025: "$906,667",
      },
      {
        player: "Guillaume Richard",
        salary2025: "$867,500",
      },
      {
        player: "Stanislav Svozil",
        salary2025: "$825,000",
      },
      {
        player: "Dysin Mayo",
        salary2025: "$775,000",
      },
      {
        player: "Ivan Fedotov",
        salary2025: "$2,125,000",
      },
      {
        player: "Evan Gardner",
        salary2025: "$870,833",
      },
      {
        player: "Nolan Lalonde",
        salary2025: "$785,556",
      },
      {
        player: "Zach Sawchenko",
        salary2025: "$775,000",
      },
    ],
  },
  {
    dallas_stars: [
      {
        player: "Tyler Myers",
        salary2025: "$3,000,000",
      },

      {
        player: "Michael Bunting",
        salary2025: "$4,500,000",
      },
      {
        player: "Mikko Rantanen",
        salary2025: "$12,000,000",
      },
      {
        player: "Roope Hintz",
        salary2025: "$8,450,000",
      },
      {
        player: "Wyatt Johnston",
        salary2025: "$8,400,000",
      },
      {
        player: "Jason Robertson",
        salary2025: "$7,750,000",
      },
      {
        player: "Matt Duchene",
        salary2025: "$4,500,000",
      },
      {
        player: "Sam Steel",
        salary2025: "$2,100,000",
      },
      {
        player: "Radek Faksa",
        salary2025: "$2,000,000",
      },
      {
        player: "Jamie Benn",
        salary2025: "$1,000,000",
      },
      {
        player: "Mavrik Bourque",
        salary2025: "$950,000",
      },
      {
        player: "Justin Hryckowian",
        salary2025: "$870,000",
      },
      {
        player: "Oskar Back",
        salary2025: "$825,000",
      },
      {
        player: "Colin Blackwell",
        salary2025: "$775,000",
      },
      {
        player: "Adam Erne",
        salary2025: "$775,000",
      },
      {
        player: "Nathan Bastian",
        salary2025: "$775,000",
      },
      {
        player: "Miro Heiskanen",
        salary2025: "$8,450,000",
      },
      {
        player: "Esa Lindell",
        salary2025: "$5,250,000",
      },
      {
        player: "Thomas Harley",
        salary2025: "$4,000,000",
      },
      {
        player: "Ilya Lyubushkin",
        salary2025: "$3,250,000",
      },
      {
        player: "Nils Lundkvist",
        salary2025: "$1,250,000",
      },
      {
        player: "Alexander Petrovic",
        salary2025: "$775,000",
      },
      {
        player: "Kyle Capobianco",
        salary2025: "$775,000",
      },
      {
        player: "Jake Oettinger",
        salary2025: "$8,250,000",
      },
      {
        player: "Casey DeSmith",
        salary2025: "$1,000,000",
      },
      {
        player: "Tyler Seguin",
        salary2025: "$3,817,293",
      },
      {
        player: "Lian Bichsel",
        salary2025: "$918,333",
      },
      {
        player: "Ryan Suter",
        salary2025: "$1,433,333",
      },
      {
        player: "Tyler Seguin",
        salary2025: "$6,032,707",
      },
      {
        player: "Harrison Scott",
        salary2025: "$975,000",
      },
      {
        player: "Emil Hemming",
        salary2025: "$942,500",
      },
      {
        player: "Jaxon Fuder",
        salary2025: "$916,667",
      },
      {
        player: "Arttu Hyry",
        salary2025: "$870,000",
      },
      {
        player: "Kyle McDonald",
        salary2025: "$870,000",
      },
      {
        player: "Justin Ertel",
        salary2025: "$867,500",
      },
      {
        player: "Ayrton Martino",
        salary2025: "$867,500",
      },
      {
        player: "Chase Wheatcroft",
        salary2025: "$862,500",
      },
      {
        player: "Matthew Seminoff",
        salary2025: "$850,000",
      },
      {
        player: "Angus MacDonell",
        salary2025: "$850,000",
      },
      {
        player: "Samu Tuomaala",
        salary2025: "$830,833",
      },
      {
        player: "Francesco Arcuri",
        salary2025: "$825,000",
      },
      {
        player: "Antonio Stranges",
        salary2025: "$775,000",
      },
      {
        player: "Kole Lind",
        salary2025: "$775,000",
      },
      {
        player: "Cameron Hughes",
        salary2025: "$775,000",
      },
      {
        player: "Trey Taylor",
        salary2025: "$975,000",
      },
      {
        player: "Connor Punnett",
        salary2025: "$870,000",
      },
      {
        player: "Luke Krys",
        salary2025: "$870,000",
      },
      {
        player: "Gavin White",
        salary2025: "$857,500",
      },
      {
        player: "Niilopekka Muhonen",
        salary2025: "$850,000",
      },
      {
        player: "Tristan Bertucci",
        salary2025: "$846,667",
      },
      {
        player: "Arno Tiefensee",
        salary2025: "$850,000",
      },
      {
        player: "Ben Kraws",
        salary2025: "$775,000",
      },
      {
        player: "Remi Poirier",
        salary2025: "$775,000",
      },
    ],
  },
  {
    detroit_red_wings: [
      {
        player: "Justin Faulk",
        salary2025: "$6,500,000",
      },
      {
        player: "David Perron",
        salary2025: "$4,000,000",
      },
      {
        player: "Dylan Larkin",
        salary2025: "$8,700,000",
      },
      {
        player: "Lucas Raymond",
        salary2025: "$8,075,000",
      },
      {
        player: "Alex DeBrincat",
        salary2025: "$7,875,000",
      },
      {
        player: "Andrew Copp",
        salary2025: "$5,625,000",
      },
      {
        player: "J.T. Compher",
        salary2025: "$5,100,000",
      },
      {
        player: "Michael Rasmussen",
        salary2025: "$3,200,000",
      },
      {
        player: "Patrick Kane",
        salary2025: "$3,000,000",
      },
      {
        player: "Mason Appleton",
        salary2025: "$2,900,000",
      },
      {
        player: "Elmer Soderblom",
        salary2025: "$1,125,000",
      },
      {
        player: "James van Riemsdyk",
        salary2025: "$1,000,000",
      },
      {
        player: "Marco Kasper",
        salary2025: "$886,667",
      },
      {
        player: "Emmitt Finnie",
        salary2025: "$821,667",
      },
      {
        player: "Moritz Seider",
        salary2025: "$8,550,000",
      },
      {
        player: "Ben Chiarot",
        salary2025: "$4,750,000",
      },
      {
        player: "Erik Gustafsson",
        salary2025: "$2,000,000",
      },
      {
        player: "Albert Johansson",
        salary2025: "$1,125,000",
      },
      {
        player: "Travis Hamonic",
        salary2025: "$1,000,000",
      },
      {
        player: "Axel Sandin-Pellikka",
        salary2025: "$918,333",
      },
      {
        player: "Simon Edvinsson",
        salary2025: "$894,167",
      },
      {
        player: "Jacob Bernard-Docker",
        salary2025: "$875,000",
      },
      {
        player: "John Gibson",
        salary2025: "$6,400,000",
      },
      {
        player: "Cam Talbot",
        salary2025: "$2,500,000",
      },
      {
        player: "Justin Abdelkader",
        salary2025: "$1,055,556",
      },
      {
        player: "Carter Bear",
        salary2025: "$975,000",
      },
      {
        player: "Michael Brandsegg-Nygard",
        salary2025: "$942,500",
      },
      {
        player: "Jesse Kiiskinen",
        salary2025: "$923,333",
      },
      {
        player: "Carter Mazur",
        salary2025: "$905,833",
      },
      {
        player: "Nate Danielson",
        salary2025: "$886,667",
      },
      {
        player: "Alexandre Doucet",
        salary2025: "$870,000",
      },
      {
        player: "Jakub Rychlovsky",
        salary2025: "$870,000",
      },
      {
        player: "Ondrej Becher",
        salary2025: "$865,000",
      },
      {
        player: "Amadeus Lombardi",
        salary2025: "$838,333",
      },
      {
        player: "Eduards Tralmaks",
        salary2025: "$775,000",
      },
      {
        player: "Dominik Shine",
        salary2025: "$775,000",
      },
      {
        player: "Austin Watson",
        salary2025: "$775,000",
      },
      {
        player: "John Leonard",
        salary2025: "$775,000",
      },
      {
        player: "Sheldon Dries",
        salary2025: "$775,000",
      },
      {
        player: "Justin Holl",
        salary2025: "$2,250,000",
      },
      {
        player: "William Wallinder",
        salary2025: "$925,000",
      },
      {
        player: "Shai Buium",
        salary2025: "$925,000",
      },
      {
        player: "Anton Johansson",
        salary2025: "$870,000",
      },
      {
        player: "Antti Tuomisto",
        salary2025: "$813,750",
      },
      {
        player: "Ian Mitchell",
        salary2025: "$775,000",
      },
      {
        player: "William Lagesson",
        salary2025: "$775,000",
      },
      {
        player: "Michal Postava",
        salary2025: "$975,000",
      },
      {
        player: "Sebastian Cossa",
        salary2025: "$863,333",
      },
      {
        player: "Carter Gylander",
        salary2025: "$855,000",
      },
    ],
  },
  {
    edmonton_oilers: [
      {
        player: "Connor Murphy",
        salary2025: "$4,400,000",
      },

      {
        player: "Colton Dach",
        salary2025: "$825,000",
      },

      {
        player: "Leon Draisaitl",
        salary2025: "$14,000,000",
      },
      {
        player: "Connor McDavid",
        salary2025: "$12,500,000",
      },
      {
        player: "Zach Hyman",
        salary2025: "$5,500,000",
      },
      {
        player: "Ryan Nugent-Hopkins",
        salary2025: "$5,125,000",
      },
      {
        player: "Trent Frederic",
        salary2025: "$3,850,000",
      },

      {
        player: "Jack Roslovic",
        salary2025: "$1,500,000",
      },
      {
        player: "Mattias Janmark",
        salary2025: "$1,450,000",
      },
      {
        player: "Kasperi Kapanen",
        salary2025: "$1,300,000",
      },
      {
        player: "Vasily Podkolzin",
        salary2025: "$1,000,000",
      },
      {
        player: "Isaac Howard",
        salary2025: "$950,000",
      },
      {
        player: "Matt Savoie",
        salary2025: "$886,667",
      },
      {
        player: "Curtis Lazar",
        salary2025: "$775,000",
      },
      {
        player: "Evan Bouchard",
        salary2025: "$10,500,000",
      },
      {
        player: "Darnell Nurse",
        salary2025: "$9,250,000",
      },
      {
        player: "Mattias Ekholm",
        salary2025: "$6,000,000",
      },
      {
        player: "Jake Walman",
        salary2025: "$3,400,000",
      },
      {
        player: "Ty Emberson",
        salary2025: "$1,300,000",
      },
      {
        player: "Spencer Stastney",
        salary2025: "$825,000",
      },
      {
        player: "Alec Regula",
        salary2025: "$775,000",
      },
      {
        player: "Tristan Jarry",
        salary2025: "$5,375,000",
      },
      {
        player: "Connor Ingram",
        salary2025: "$1,150,500",
      },
      {
        player: "Calvin Pickard",
        salary2025: "$1,000,000",
      },
      {
        player: "Adam Henrique",
        salary2025: "$3,000,000",
      },
      {
        player: "Jack Campbell",
        salary2025: "$2,300,000",
      },
      {
        player: "Max Jones",
        salary2025: "$1,000,000",
      },
      {
        player: "Josh Samanski",
        salary2025: "$975,000",
      },
      {
        player: "Quinn Hutson",
        salary2025: "$875,000",
      },
      {
        player: "Viljami Marjala",
        salary2025: "$872,500",
      },
      {
        player: "James Stefan",
        salary2025: "$870,000",
      },
      {
        player: "Jayden Grubbe",
        salary2025: "$867,500",
      },
      {
        player: "Connor Clattenburg",
        salary2025: "$828,333",
      },
      {
        player: "Brady Stonehouse",
        salary2025: "$821,667",
      },
      {
        player: "Matvey Petrov",
        salary2025: "$803,333",
      },
      {
        player: "Roby Jarventie",
        salary2025: "$775,000",
      },
      {
        player: "James Hamblin",
        salary2025: "$775,000",
      },
      {
        player: "Sam Poulin",
        salary2025: "$775,000",
      },
      {
        player: "Josh Brown",
        salary2025: "$1,000,000",
      },
      {
        player: "Atro Leppanen",
        salary2025: "$975,000",
      },
      {
        player: "Damien Carfagna",
        salary2025: "$862,500",
      },
      {
        player: "Beau Akey",
        salary2025: "$831,667",
      },
      {
        player: "Cam Dineen",
        salary2025: "$775,000",
      },
      {
        player: "Riley Stillman",
        salary2025: "$775,000",
      },
      {
        player: "Connor Ungar",
        salary2025: "$860,000",
      },
      {
        player: "Nathaniel Day",
        salary2025: "$856,667",
      },
      {
        player: "Samuel Jonsson",
        salary2025: "$855,000",
      },
      {
        player: "Matt Tomkins",
        salary2025: "$775,000",
      },
    ],
  },
  {
    florida_panthers: [
      {
        player: "Vinnie Hinostroza",
        salary2025: "$775,000",
      },
      {
        player: "Cole Reinhardt",
        salary2025: "$812,500",
      },
      {
        player: "Sam Reinhart",
        salary2025: "$8,625,000",
      },
      {
        player: "Sam Bennett",
        salary2025: "$8,000,000",
      },
      {
        player: "Carter Verhaeghe",
        salary2025: "$7,000,000",
      },
      {
        player: "Brad Marchand",
        salary2025: "$5,250,000",
      },
      {
        player: "Anton Lundell",
        salary2025: "$5,000,000",
      },
      {
        player: "Evan Rodrigues",
        salary2025: "$3,000,000",
      },
      {
        player: "Eetu Luostarinen",
        salary2025: "$3,000,000",
      },
      {
        player: "Jesper Boqvist",
        salary2025: "$1,500,000",
      },
      {
        player: "Sandis Vilmanis",
        salary2025: "$855,000",
      },
      {
        player: "A.J. Greer",
        salary2025: "$850,000",
      },
      {
        player: "Cole Schwindt",
        salary2025: "$825,000",
      },
      {
        player: "Jonah Gadjovich",
        salary2025: "$775,000",
      },
      {
        player: "Mackie Samoskevich",
        salary2025: "$775,000",
      },
      {
        player: "Luke Kunin",
        salary2025: "$775,000",
      },
      {
        player: "Jack Studnicka",
        salary2025: "$775,000",
      },
      {
        player: "Noah Gregor",
        salary2025: "$775,000",
      },
      {
        player: "Seth Jones",
        salary2025: "$7,000,000",
      },
      {
        player: "Aaron Ekblad",
        salary2025: "$6,100,000",
      },
      {
        player: "Gustav Forsling",
        salary2025: "$5,750,000",
      },
      {
        player: "Niko Mikkola",
        salary2025: "$2,500,000",
      },
      {
        player: "Dmitry Kulikov",
        salary2025: "$1,150,000",
      },
      {
        player: "Uvis Balinskis",
        salary2025: "$850,000",
      },
      {
        player: "Donovan Sebrango",
        salary2025: "$775,000",
      },
      {
        player: "Tobias Bjornfot",
        salary2025: "$775,000",
      },
      {
        player: "Sergei Bobrovsky",
        salary2025: "$10,000,000",
      },
      {
        player: "Daniil Tarasov",
        salary2025: "$1,050,000",
      },
      {
        player: "Matthew Tkachuk",
        salary2025: "$3,817,293",
      },
      {
        player: "Aleksander Barkov",
        salary2025: "$3,817,293",
      },
      {
        player: "Tomas Nosek",
        salary2025: "$775,000",
      },
      {
        player: "Matthew Tkachuk",
        salary2025: "$5,682,707",
      },
      {
        player: "Aleksander Barkov",
        salary2025: "$6,182,707",
      },
      {
        player: "Ben Steeves",
        salary2025: "$950,000",
      },
      {
        player: "Jack Devine",
        salary2025: "$950,000",
      },
      {
        player: "Ryan McAllister",
        salary2025: "$896,667",
      },
      {
        player: "Gracyn Sawchyn",
        salary2025: "$846,667",
      },
      {
        player: "Josh Davies",
        salary2025: "$828,333",
      },
      {
        player: "Hunter St. Martin",
        salary2025: "$828,333",
      },
      {
        player: "Kai Schwindt",
        salary2025: "$798,333",
      },
      {
        player: "MacKenzie Entwistle",
        salary2025: "$775,000",
      },
      {
        player: "Nolan Foote",
        salary2025: "$775,000",
      },
      {
        player: "Wilmer Skoog",
        salary2025: "$775,000",
      },
      {
        player: "Mikulas Hovorka",
        salary2025: "$950,000",
      },
      {
        player: "Marek Alscher",
        salary2025: "$865,000",
      },
      {
        player: "Evan Nause",
        salary2025: "$864,167",
      },
      {
        player: "Ludvig Jansson",
        salary2025: "$855,000",
      },
      {
        player: "Mike Benning",
        salary2025: "$775,000",
      },
      {
        player: "Cooper Black",
        salary2025: "$950,000",
      },
      {
        player: "Kirill Gerasimyuk",
        salary2025: "$875,000",
      },
    ],
  },
  {
    los_angeles_kings: [
      {
        player: "Mathieu Joseph",
        salary2025: "$2,950,000",
      },

      {
        player: "Scott Laughton",
        salary2025: "$1,500,000",
      },

      {
        player: "Artemi Panarin",
        salary2025: "$11,642,857",
      },

      {
        player: "Kevin Fiala",
        salary2025: "$7,875,000",
      },
      {
        player: "Anze Kopitar",
        salary2025: "$7,000,000",
      },
      {
        player: "Quinton Byfield",
        salary2025: "$6,250,000",
      },
      {
        player: "Adrian Kempe",
        salary2025: "$5,500,000",
      },
      {
        player: "Andrei Kuzmenko",
        salary2025: "$4,300,000",
      },
      {
        player: "Trevor Moore",
        salary2025: "$4,200,000",
      },
      {
        player: "Alex Laferriere",
        salary2025: "$4,100,000",
      },
      {
        player: "Joel Armia",
        salary2025: "$2,500,000",
      },
      {
        player: "Samuel Helenius",
        salary2025: "$805,833",
      },
      {
        player: "Alex Turcotte",
        salary2025: "$775,000",
      },
      {
        player: "Jeff Malott",
        salary2025: "$775,000",
      },
      {
        player: "Taylor Ward",
        salary2025: "$775,000",
      },
      {
        player: "Andre Lee",
        salary2025: "$775,000",
      },
      {
        player: "Drew Doughty",
        salary2025: "$11,000,000",
      },
      {
        player: "Cody Ceci",
        salary2025: "$4,500,000",
      },
      {
        player: "Mikey Anderson",
        salary2025: "$4,125,000",
      },
      {
        player: "Brian Dumoulin",
        salary2025: "$4,000,000",
      },
      {
        player: "Joel Edmundson",
        salary2025: "$3,850,000",
      },
      {
        player: "Brandt Clarke",
        salary2025: "$863,333",
      },
      {
        player: "Jacob Moverare",
        salary2025: "$775,000",
      },
      {
        player: "Darcy Kuemper",
        salary2025: "$5,250,000",
      },
      {
        player: "Anton Forsberg",
        salary2025: "$2,250,000",
      },
      {
        player: "Mike Richards",
        salary2025: "$600,000",
      },
      {
        player: "Vojtech Cihar",
        salary2025: "$975,000",
      },
      {
        player: "Liam Greentree",
        salary2025: "$942,500",
      },
      {
        player: "Jimmy Lombardi",
        salary2025: "$923,333",
      },
      {
        player: "Kenny Connors",
        salary2025: "$867,500",
      },
      {
        player: "Jared Wright",
        salary2025: "$867,500",
      },
      {
        player: "Aatu Jamsen",
        salary2025: "$852,500",
      },
      {
        player: "Kaleb Lawrence",
        salary2025: "$852,500",
      },
      {
        player: "Francesco Pinelli",
        salary2025: "$845,000",
      },
      {
        player: "Koehn Ziemmer",
        salary2025: "$816,667",
      },
      {
        player: "Glenn Gawdin",
        salary2025: "$775,000",
      },
      {
        player: "Logan Brown",
        salary2025: "$775,000",
      },
      {
        player: "Martin Chromiak",
        salary2025: "$775,000",
      },
      {
        player: "Nikita Alexandrov",
        salary2025: "$775,000",
      },
      {
        player: "Cole Guttman",
        salary2025: "$775,000",
      },
      {
        player: "Kyle Burroughs",
        salary2025: "$1,100,000",
      },
      {
        player: "Kirill Kirsanov",
        salary2025: "$925,000",
      },
      {
        player: "Jared Woolley",
        salary2025: "$875,000",
      },
      {
        player: "Otto Salin",
        salary2025: "$875,000",
      },
      {
        player: "Jakub Dvorak",
        salary2025: "$840,000",
      },
      {
        player: "Angus Booth",
        salary2025: "$826,667",
      },
      {
        player: "Joe Hicketts",
        salary2025: "$775,000",
      },
      {
        player: "Samuel Bolduc",
        salary2025: "$775,000",
      },
      {
        player: "Carter George",
        salary2025: "$845,833",
      },
      {
        player: "Erik Portillo",
        salary2025: "$783,333",
      },
      {
        player: "Pheonix Copley",
        salary2025: "$775,000",
      },
    ],
  },
  {
    minnesota_wild: [
      {
        player: "Jeff Petry",
        salary2025: "$775,000",
      },

      {
        player: "Michael McCarron",
        salary2025: "$900,000",
      },
      {
        player: "Nick Foligno",
        salary2025: "$4,500,000",
      },

      {
        player: "Robby Fabbri",
        salary2025: "$775,000",
      },

      {
        player: "Bobby Brink",
        salary2025: "$1,500,000",
      },
      {
        player: "Kirill Kaprizov",
        salary2025: "$9,000,000",
      },
      {
        player: "Matt Boldy",
        salary2025: "$7,000,000",
      },
      {
        player: "Joel Eriksson Ek",
        salary2025: "$5,250,000",
      },
      {
        player: "Vladimir Tarasenko",
        salary2025: "$4,750,000",
      },
      {
        player: "Mats Zuccarello",
        salary2025: "$4,125,000",
      },
      {
        player: "Marcus Foligno",
        salary2025: "$4,000,000",
      },
      {
        player: "Ryan Hartman",
        salary2025: "$4,000,000",
      },
      {
        player: "Yakov Trenin",
        salary2025: "$3,500,000",
      },
      {
        player: "Nico Sturm",
        salary2025: "$2,000,000",
      },
      {
        player: "Danila Yurov",
        salary2025: "$950,000",
      },
      {
        player: "Hunter Haight",
        salary2025: "$865,833",
      },
      {
        player: "Marcus Johansson",
        salary2025: "$800,000",
      },
      {
        player: "Ben Jones",
        salary2025: "$775,000",
      },
      {
        player: "Tyler Pitlick",
        salary2025: "$775,000",
      },
      {
        player: "Nicolas Aube-Kubel",
        salary2025: "$775,000",
      },
      {
        player: "Brock Faber",
        salary2025: "$8,500,000",
      },
      {
        player: "Quinn Hughes",
        salary2025: "$7,850,000",
      },
      {
        player: "Jared Spurgeon",
        salary2025: "$7,575,000",
      },
      {
        player: "Jonas Brodin",
        salary2025: "$6,000,000",
      },
      {
        player: "Jake Middleton",
        salary2025: "$4,350,000",
      },
      {
        player: "Zach Bogosian",
        salary2025: "$1,250,000",
      },
      {
        player: "David Jiricek",
        salary2025: "$918,333",
      },
      {
        player: "David Spacek",
        salary2025: "$862,500",
      },
      {
        player: "Daemon Hunt",
        salary2025: "$775,000",
      },
      {
        player: "Filip Gustavsson",
        salary2025: "$3,750,000",
      },
      {
        player: "Jesper Wallstedt",
        salary2025: "$2,200,000",
      },
      {
        player: "Zach Parise",
        salary2025: "$833,333",
      },
      {
        player: "Ryan Suter",
        salary2025: "$833,333",
      },
      {
        player: "Riley Heidt",
        salary2025: "$918,333",
      },
      {
        player: "Caedan Bankier",
        salary2025: "$867,500",
      },
      {
        player: "Rasmus Kumpulainen",
        salary2025: "$865,833",
      },
      {
        player: "Oskar Olausson",
        salary2025: "$863,333",
      },
      {
        player: "Cameron Butler",
        salary2025: "$858,333",
      },
      {
        player: "Bradley Marek",
        salary2025: "$790,000",
      },
      {
        player: "Boris Katchouk",
        salary2025: "$775,000",
      },
      {
        player: "Jack Peart",
        salary2025: "$925,000",
      },
      {
        player: "Carson Lambos",
        salary2025: "$863,333",
      },
      {
        player: "Stevie Leskovar",
        salary2025: "$860,000",
      },
      {
        player: "Ben Gleason",
        salary2025: "$800,000",
      },
      {
        player: "Matt Kiersted",
        salary2025: "$775,000",
      },
      {
        player: "Chase Wutzke",
        salary2025: "$962,500",
      },
      {
        player: "Samuel Hlavaj",
        salary2025: "$875,000",
      },
      {
        player: "Riley Mercer",
        salary2025: "$819,167",
      },
      {
        player: "Cal Petersen",
        salary2025: "$775,000",
      },
    ],
  },
  {
    montreal_canadiens: [
      {
        player: "Patrik Laine",
        salary2025: "$8,700,000",
      },
      {
        player: "Nick Suzuki",
        salary2025: "$7,875,000",
      },
      {
        player: "Cole Caufield",
        salary2025: "$7,850,000",
      },
      {
        player: "Juraj Slafkovsky",
        salary2025: "$7,600,000",
      },
      {
        player: "Brendan Gallagher",
        salary2025: "$6,500,000",
      },
      {
        player: "Josh Anderson",
        salary2025: "$5,500,000",
      },
      {
        player: "Phillip Danault",
        salary2025: "$5,500,000",
      },
      {
        player: "Alex Newhook",
        salary2025: "$2,900,000",
      },
      {
        player: "Alexandre Texier",
        salary2025: "$1,000,000",
      },
      {
        player: "Ivan Demidov",
        salary2025: "$940,833",
      },
      {
        player: "Oliver Kapanen",
        salary2025: "$925,000",
      },
      {
        player: "Joe Veleno",
        salary2025: "$900,000",
      },
      {
        player: "Zachary Bolduc",
        salary2025: "$863,333",
      },
      {
        player: "Sammy Blais",
        salary2025: "$775,000",
      },
      {
        player: "Noah Dobson",
        salary2025: "$9,500,000",
      },
      {
        player: "Kaiden Guhle",
        salary2025: "$5,550,000",
      },
      {
        player: "Mike Matheson",
        salary2025: "$4,875,000",
      },
      {
        player: "Alexandre Carrier",
        salary2025: "$3,750,000",
      },
      {
        player: "Jayden Struble",
        salary2025: "$1,412,500",
      },
      {
        player: "Arber Xhekaj",
        salary2025: "$1,300,000",
      },
      {
        player: "Lane Hutson",
        salary2025: "$950,000",
      },
      {
        player: "Samuel Montembeault",
        salary2025: "$3,150,000",
      },
      {
        player: "Jakub Dobes",
        salary2025: "$965,000",
      },
      {
        player: "Kirby Dach",
        salary2025: "$3,362,500",
      },
      {
        player: "Jake Evans",
        salary2025: "$2,850,000",
      },
      {
        player: "Vinzenz Rohrer",
        salary2025: "$950,000",
      },
      {
        player: "Luke Tuch",
        salary2025: "$912,500",
      },
      {
        player: "Filip Mesar",
        salary2025: "$886,667",
      },
      {
        player: "Tyler Thorpe",
        salary2025: "$868,333",
      },
      {
        player: "Florian Xhekaj",
        salary2025: "$866,667",
      },
      {
        player: "Jared Davidson",
        salary2025: "$862,500",
      },
      {
        player: "Owen Beck",
        salary2025: "$853,333",
      },
      {
        player: "Riley Kidney",
        salary2025: "$836,667",
      },
      {
        player: "Joshua Roy",
        salary2025: "$835,000",
      },
      {
        player: "Alex Belzile",
        salary2025: "$775,000",
      },
      {
        player: "Lucas Condotta",
        salary2025: "$775,000",
      },
      {
        player: "Sean Farrell",
        salary2025: "$775,000",
      },
      {
        player: "Bryce Pickford",
        salary2025: "$940,833",
      },
      {
        player: "Adam Engstrom",
        salary2025: "$896,667",
      },
      {
        player: "David Reinbacher",
        salary2025: "$886,667",
      },
      {
        player: "Gannon Laroque",
        salary2025: "$836,667",
      },
      {
        player: "Nate Clurman",
        salary2025: "$775,000",
      },
      {
        player: "William Trudeau",
        salary2025: "$775,000",
      },
      {
        player: "Marc Del Gaizo",
        salary2025: "$775,000",
      },
      {
        player: "Kaapo Kahkonen",
        salary2025: "$1,150,000",
      },
      {
        player: "Jacob Fowler",
        salary2025: "$923,333",
      },
    ],
  },
  {
    nashville_predators: [
      {
        player: "Filip Forsberg",
        salary2025: "$8,500,000",
      },
      {
        player: "Steven Stamkos",
        salary2025: "$8,000,000",
      },
      {
        player: "Jonathan Marchessault",
        salary2025: "$5,500,000",
      },
      {
        player: "Ryan O'Reilly",
        salary2025: "$4,500,000",
      },
      {
        player: "Erik Haula",
        salary2025: "$3,150,000",
      },
      {
        player: "Luke Evangelista",
        salary2025: "$3,000,000",
      },
      {
        player: "Matthew Wood",
        salary2025: "$950,000",
      },
      {
        player: "Fedor Svechkov",
        salary2025: "$925,000",
      },
      {
        player: "Michael McCarron",
        salary2025: "$900,000",
      },
      {
        player: "Reid Schaefer",
        salary2025: "$886,667",
      },
      {
        player: "Tyson Jost",
        salary2025: "$775,000",
      },
      {
        player: "Ozzy Wiesblatt",
        salary2025: "$775,000",
      },
      {
        player: "Roman Josi",
        salary2025: "$9,059,000",
      },
      {
        player: "Brady Skjei",
        salary2025: "$7,000,000",
      },
      {
        player: "Nicolas Hague",
        salary2025: "$5,500,000",
      },
      {
        player: "Nick Perbix",
        salary2025: "$2,750,000",
      },
      {
        player: "Justin Barron",
        salary2025: "$1,150,000",
      },
      {
        player: "Adam Wilsby",
        salary2025: "$775,000",
      },
      {
        player: "Juuse Saros",
        salary2025: "$7,740,000",
      },
      {
        player: "Justus Annunen",
        salary2025: "$837,500",
      },
      {
        player: "Colton Sissons",
        salary2025: "$1,428,572",
      },
      {
        player: "Mattias Ekholm",
        salary2025: "$250,000",
      },
      {
        player: "Matt Duchene",
        salary2025: "$6,555,556",
      },
      {
        player: "Kyle Turris",
        salary2025: "$2,000,000",
      },
      {
        player: "Brady Martin",
        salary2025: "$975,000",
      },
      {
        player: "Ryder Rolston",
        salary2025: "$895,000",
      },
      {
        player: "David Edstrom",
        salary2025: "$886,667",
      },
      {
        player: "Joakim Kemell",
        salary2025: "$886,667",
      },
      {
        player: "Zachary L'Heureux",
        salary2025: "$863,333",
      },
      {
        player: "Joey Willis",
        salary2025: "$860,000",
      },
      {
        player: "Cole O'Hara",
        salary2025: "$860,000",
      },
      {
        player: "Austin Roest",
        salary2025: "$845,000",
      },
      {
        player: "Hiroki Gojsic",
        salary2025: "$835,000",
      },
      {
        player: "Kalan Lind",
        salary2025: "$806,667",
      },
      {
        player: "Jacob Lucchini",
        salary2025: "$775,000",
      },
      {
        player: "Navrin Mutter",
        salary2025: "$775,000",
      },
      {
        player: "Ryan Ufko",
        salary2025: "$925,000",
      },
      {
        player: "Tanner Molendyk",
        salary2025: "$886,667",
      },
      {
        player: "Andrew Gibson",
        salary2025: "$865,000",
      },
      {
        player: "Jack Matier",
        salary2025: "$801,667",
      },
      {
        player: "Jordan Oesterle",
        salary2025: "$775,000",
      },
      {
        player: "Kevin Gravel",
        salary2025: "$775,000",
      },
      {
        player: "Andreas Englund",
        salary2025: "$775,000",
      },
      {
        player: "Magnus Chrona",
        salary2025: "$855,000",
      },
      {
        player: "Matt Murray",
        salary2025: "$775,000",
      },
    ],
  },
  {
    new_jersey_devils: [
      {
        player: "Maxim Tsyplakov",
        salary2025: "$2,250,000",
      },

      {
        player: "Nick Bjugstad",
        salary2025: "$1,750,000",
      },
      {
        player: "Timo Meier",
        salary2025: "$8,800,000",
      },
      {
        player: "Jack Hughes",
        salary2025: "$8,000,000",
      },
      {
        player: "Jesper Bratt",
        salary2025: "$7,875,000",
      },
      {
        player: "Nico Hischier",
        salary2025: "$7,250,000",
      },
      {
        player: "Dawson Mercer",
        salary2025: "$4,000,000",
      },
      {
        player: "Connor Brown",
        salary2025: "$3,000,000",
      },
      {
        player: "Cody Glass",
        salary2025: "$2,500,000",
      },
      {
        player: "Evgenii Dadonov",
        salary2025: "$1,000,000",
      },
      {
        player: "Arseny Gritsyuk",
        salary2025: "$925,000",
      },
      {
        player: "Paul Cotter",
        salary2025: "$775,000",
      },
      {
        player: "Marc McLaughlin",
        salary2025: "$775,000",
      },

      {
        player: "Dougie Hamilton",
        salary2025: "$9,000,000",
      },
      {
        player: "Luke Hughes",
        salary2025: "$9,000,000",
      },
      {
        player: "Brett Pesce",
        salary2025: "$5,500,000",
      },
      {
        player: "Brenden Dillon",
        salary2025: "$4,000,000",
      },
      {
        player: "Johnathan Kovacevic",
        salary2025: "$4,000,000",
      },
      {
        player: "Jonas Siegenthaler",
        salary2025: "$3,400,000",
      },
      {
        player: "Simon Nemec",
        salary2025: "$918,333",
      },
      {
        player: "Jacob Markstrom",
        salary2025: "$4,125,000",
      },
      {
        player: "Jake Allen",
        salary2025: "$1,800,000",
      },
      {
        player: "Stefan Noesen",
        salary2025: "$2,750,000",
      },
      {
        player: "Zack MacEwen",
        salary2025: "$775,000",
      },
      {
        player: "Juho Lammikko",
        salary2025: "$800,000",
      },
      {
        player: "Colton White",
        salary2025: "$775,000",
      },
      {
        player: "Lenni Hameenaho",
        salary2025: "$950,000",
      },
      {
        player: "Shane Lachance",
        salary2025: "$925,000",
      },
      {
        player: "Dylan Wendt",
        salary2025: "$870,000",
      },
      {
        player: "Cam Squires",
        salary2025: "$838,333",
      },
      {
        player: "Josh Filmon",
        salary2025: "$838,333",
      },
      {
        player: "Ryan Schmelzer",
        salary2025: "$775,000",
      },
      {
        player: "Thomas Bordeleau",
        salary2025: "$775,000",
      },
      {
        player: "Jonathan Gruden",
        salary2025: "$775,000",
      },
      {
        player: "Mike Hardman",
        salary2025: "$775,000",
      },
      {
        player: "Brian Halonen",
        salary2025: "$775,000",
      },
      {
        player: "Xavier Parent",
        salary2025: "$775,000",
      },
      {
        player: "Nathan Legare",
        salary2025: "$775,000",
      },
      {
        player: "Angus Crookshank",
        salary2025: "$775,000",
      },
      {
        player: "Mikael Diotte",
        salary2025: "$950,000",
      },
      {
        player: "Seamus Casey",
        salary2025: "$950,000",
      },
      {
        player: "Ethan Edwards",
        salary2025: "$925,000",
      },
      {
        player: "Jeremy Hanzel",
        salary2025: "$851,667",
      },
      {
        player: "Topias Vilen",
        salary2025: "$836,667",
      },
      {
        player: "Calen Addison",
        salary2025: "$775,000",
      },
      {
        player: "Dennis Cholowski",
        salary2025: "$775,000",
      },
      {
        player: "Tyler Brennan",
        salary2025: "$870,000",
      },
      {
        player: "Jakub Malek",
        salary2025: "$867,500",
      },
      {
        player: "Nico Daws",
        salary2025: "$812,500",
      },
    ],
  },
  {
    new_york_islanders: [
      {
        player: "Carson Soucy",
        salary2025: "$3,250,000",
      },

      {
        player: "Brayden Schenn",
        salary2025: "$6,500,000",
      },

      {
        player: "Ondrej Palat",
        salary2025: "$6,000,000",
      },

      {
        player: "Mathew Barzal",
        salary2025: "$9,150,000",
      },
      {
        player: "Bo Horvat",
        salary2025: "$8,500,000",
      },
      {
        player: "Anders Lee",
        salary2025: "$7,000,000",
      },
      {
        player: "Jean-Gabriel Pageau",
        salary2025: "$5,000,000",
      },
      {
        player: "Kyle Palmieri",
        salary2025: "$4,750,000",
      },
      {
        player: "Simon Holmstrom",
        salary2025: "$3,625,000",
      },
      {
        player: "Anthony Duclair",
        salary2025: "$3,500,000",
      },
      {
        player: "Casey Cizikas",
        salary2025: "$2,500,000",
      },
      {
        player: "Emil Heineman",
        salary2025: "$1,100,000",
      },
      {
        player: "Maxim Shabanov",
        salary2025: "$975,000",
      },
      {
        player: "Calum Ritchie",
        salary2025: "$918,333",
      },
      {
        player: "Marc Gatcomb",
        salary2025: "$900,000",
      },
      {
        player: "Kyle MacLean",
        salary2025: "$775,000",
      },
      {
        player: "Alexander Romanov",
        salary2025: "$6,250,000",
      },
      {
        player: "Ryan Pulock",
        salary2025: "$6,150,000",
      },
      {
        player: "Adam Pelech",
        salary2025: "$5,750,000",
      },
      {
        player: "Scott Mayfield",
        salary2025: "$3,500,000",
      },
      {
        player: "Tony DeAngelo",
        salary2025: "$1,750,000",
      },
      {
        player: "Matthew Schaefer",
        salary2025: "$975,000",
      },
      {
        player: "Adam Boqvist",
        salary2025: "$850,000",
      },
      {
        player: "Cole McWard",
        salary2025: "$775,000",
      },
      {
        player: "Ilya Sorokin",
        salary2025: "$8,250,000",
      },
      {
        player: "Semyon Varlamov",
        salary2025: "$2,750,000",
      },
      {
        player: "David Rittich",
        salary2025: "$1,000,000",
      },
      {
        player: "Pierre Engvall",
        salary2025: "$3,000,000",
      },
      {
        player: "Victor Eklund",
        salary2025: "$975,000",
      },
      {
        player: "Daniil Prokhorov",
        salary2025: "$915,000",
      },
      {
        player: "Gleb Veremyev",
        salary2025: "$885,000",
      },
      {
        player: "Matthew Maggio",
        salary2025: "$870,000",
      },
      {
        player: "Camden Thiesing",
        salary2025: "$870,000",
      },
      {
        player: "Alex Jefferies",
        salary2025: "$867,500",
      },
      {
        player: "Eetu Liukas",
        salary2025: "$867,500",
      },
      {
        player: "Daylan Kuefler",
        salary2025: "$840,000",
      },
      {
        player: "Jesse Nurmi",
        salary2025: "$838,333",
      },
      {
        player: "Joey Larson",
        salary2025: "$823,750",
      },
      {
        player: "Adam Beckman",
        salary2025: "$775,000",
      },
      {
        player: "Julien Gauthier",
        salary2025: "$775,000",
      },
      {
        player: "Liam Foudy",
        salary2025: "$775,000",
      },
      {
        player: "Matthew Highmore",
        salary2025: "$775,000",
      },
      {
        player: "Jesse Pulkkinen",
        salary2025: "$880,833",
      },
      {
        player: "Isaiah George",
        salary2025: "$838,333",
      },
      {
        player: "Marshall Warren",
        salary2025: "$825,000",
      },
      {
        player: "Calle Odelius",
        salary2025: "$815,000",
      },
      {
        player: "Travis Mitchell",
        salary2025: "$775,000",
      },
      {
        player: "Ethan Bear",
        salary2025: "$775,000",
      },
      {
        player: "Tristan Lennox",
        salary2025: "$867,500",
      },
      {
        player: "Henrik Tikkanen",
        salary2025: "$823,750",
      },
      {
        player: "Marcus Hogberg",
        salary2025: "$775,000",
      },
    ],
  },
  {
    new_york_rangers: [
      {
        player: "Vincent Iorio",
        salary2025: "$814,167",
      },
      {
        player: "Tye Kartye",
        salary2025: "$1,250,000",
      },

      {
        player: "Mika Zibanejad",
        salary2025: "$8,500,000",
      },
      {
        player: "J.T. Miller",
        salary2025: "$8,000,000",
      },
      {
        player: "Alexis Lafrenière",
        salary2025: "$7,450,000",
      },
      {
        player: "Vincent Trocheck",
        salary2025: "$5,625,000",
      },
      {
        player: "Will Cuylle",
        salary2025: "$3,900,000",
      },
      {
        player: "Taylor Raddysh",
        salary2025: "$1,500,000",
      },
      {
        player: "Sam Carrick",
        salary2025: "$1,000,000",
      },
      {
        player: "Matt Rempe",
        salary2025: "$975,000",
      },
      {
        player: "Gabe Perreault",
        salary2025: "$941,667",
      },
      {
        player: "Noah Laba",
        salary2025: "$870,000",
      },
      {
        player: "Brennan Othmann",
        salary2025: "$863,333",
      },
      {
        player: "Jonny Brodzinski",
        salary2025: "$787,500",
      },
      {
        player: "Vladislav Gavrikov",
        salary2025: "$7,000,000",
      },
      {
        player: "Will Borgen",
        salary2025: "$4,100,000",
      },
      {
        player: "Braden Schneider",
        salary2025: "$2,200,000",
      },
      {
        player: "Urho Vaakanainen",
        salary2025: "$1,550,000",
      },
      {
        player: "Scott Morrow",
        salary2025: "$916,667",
      },
      {
        player: "Matthew Robertson",
        salary2025: "$775,000",
      },
      {
        player: "Connor Mackey",
        salary2025: "$775,000",
      },
      {
        player: "Igor Shesterkin",
        salary2025: "$11,500,000",
      },
      {
        player: "Jonathan Quick",
        salary2025: "$1,550,000",
      },
      {
        player: "Spencer Martin",
        salary2025: "$775,000",
      },
      {
        player: "Adam Fox",
        salary2025: "$3,817,293",
      },
      {
        player: "Adam Edstrom",
        salary2025: "$975,000",
      },
      {
        player: "Conor Sheary",
        salary2025: "$775,000",
      },
      {
        player: "Juuso Parssinen",
        salary2025: "$100,000",
      },
      {
        player: "Adam Fox",
        salary2025: "$5,682,707",
      },
      {
        player: "Nathan Aspinall",
        salary2025: "$925,000",
      },
      {
        player: "Carey Terrance",
        salary2025: "$886,667",
      },
      {
        player: "Jaroslav Chmelar",
        salary2025: "$867,500",
      },
      {
        player: "Brett Berard",
        salary2025: "$867,500",
      },
      {
        player: "Kalle Vaisanen",
        salary2025: "$863,333",
      },
      {
        player: "Dylan Roobroeck",
        salary2025: "$850,000",
      },
      {
        player: "Bryce McConnell-Barker",
        salary2025: "$838,333",
      },
      {
        player: "Adam Sykora",
        salary2025: "$806,667",
      },
      {
        player: "Trey Fix-Wolansky",
        salary2025: "$775,000",
      },
      {
        player: "Brendan Brisson",
        salary2025: "$775,000",
      },
      {
        player: "Justin Dowling",
        salary2025: "$775,000",
      },
      {
        player: "Anton Blidh",
        salary2025: "$775,000",
      },
      {
        player: "Juuso Parssinen",
        salary2025: "$100,000",
      },
      {
        player: "Jackson Dorrington",
        salary2025: "$851,667",
      },
      {
        player: "Derrick Pouliot",
        salary2025: "$775,000",
      },
      {
        player: "Casey Fitzgerald",
        salary2025: "$775,000",
      },
      {
        player: "Brandon Scanlin",
        salary2025: "$775,000",
      },
      {
        player: "Callum Tung",
        salary2025: "$872,500",
      },
      {
        player: "Hugo Ollas",
        salary2025: "$855,000",
      },
      {
        player: "Talyn Boyko",
        salary2025: "$775,000",
      },
      {
        player: "Dylan Garand",
        salary2025: "$775,000",
      },
    ],
  },
  {
    ottawa_senators: [
      {
        player: "Warren Foegele",
        salary2025: "$3,500,000",
      },
      {
        player: "Tim Stutzle",
        salary2025: "$8,350,000",
      },
      {
        player: "Brady Tkachuk",
        salary2025: "$8,205,714",
      },
      {
        player: "Dylan Cozens",
        salary2025: "$7,100,000",
      },
      {
        player: "Drake Batherson",
        salary2025: "$4,975,000",
      },
      {
        player: "Fabian Zetterlund",
        salary2025: "$4,275,000",
      },
      {
        player: "Shane Pinto",
        salary2025: "$3,750,000",
      },
      {
        player: "Ridly Greig",
        salary2025: "$3,250,000",
      },
      {
        player: "Michael Amadio",
        salary2025: "$2,600,000",
      },
      {
        player: "Claude Giroux",
        salary2025: "$2,000,000",
      },
      {
        player: "Lars Eller",
        salary2025: "$1,250,000",
      },
      {
        player: "Kurtis MacDermid",
        salary2025: "$1,150,000",
      },
      {
        player: "Nick Cousins",
        salary2025: "$825,000",
      },
      {
        player: "Jake Sanderson",
        salary2025: "$8,050,000",
      },
      {
        player: "Thomas Chabot",
        salary2025: "$8,000,000",
      },
      {
        player: "Artem Zub",
        salary2025: "$4,600,000",
      },
      {
        player: "Nick Jensen",
        salary2025: "$4,050,000",
      },
      {
        player: "Tyler Kleven",
        salary2025: "$1,600,000",
      },
      {
        player: "Jordan Spence",
        salary2025: "$1,500,000",
      },
      {
        player: "Nikolas Matinpalo",
        salary2025: "$875,000",
      },
      {
        player: "Linus Ullmark",
        salary2025: "$8,250,000",
      },
      {
        player: "Leevi Merilainen",
        salary2025: "$1,050,000",
      },
      {
        player: "James Reimer",
        salary2025: "$850,000",
      },
      {
        player: "Joonas Korpisalo",
        salary2025: "$1,000,000",
      },
      {
        player: "Colin White",
        salary2025: "$875,000",
      },
      {
        player: "Stephen Halliday",
        salary2025: "$950,000",
      },
      {
        player: "Lucas Ellinas",
        salary2025: "$875,000",
      },
      {
        player: "Tyler Boucher",
        salary2025: "$863,333",
      },
      {
        player: "Jake Chiasson",
        salary2025: "$843,333",
      },
      {
        player: "Oskar Pettersson",
        salary2025: "$835,000",
      },
      {
        player: "Garrett Pilon",
        salary2025: "$775,000",
      },
      {
        player: "Wyatt Bongiovanni",
        salary2025: "$775,000",
      },
      {
        player: "Jan Jenik",
        salary2025: "$775,000",
      },
      {
        player: "Arthur Kaliyev",
        salary2025: "$775,000",
      },
      {
        player: "Hayden Hodgson",
        salary2025: "$775,000",
      },
      {
        player: "Olle Lycksell",
        salary2025: "$775,000",
      },
      {
        player: "Xavier Bourgault",
        salary2025: "$775,000",
      },
      {
        player: "Carter Yakemchuk",
        salary2025: "$942,500",
      },
      {
        player: "Dennis Gilbert",
        salary2025: "$875,000",
      },
      {
        player: "Matthew Andonovski",
        salary2025: "$836,667",
      },
      {
        player: "Cameron Crotty",
        salary2025: "$812,500",
      },
      {
        player: "Djibril Toure",
        salary2025: "$805,000",
      },
      {
        player: "Tomas Hamara",
        salary2025: "$803,333",
      },
      {
        player: "Jorian Donovan",
        salary2025: "$796,667",
      },
      {
        player: "Lassi Thomson",
        salary2025: "$775,000",
      },
      {
        player: "Jackson Parsons",
        salary2025: "$829,167",
      },
      {
        player: "Mads Sogaard",
        salary2025: "$775,000",
      },
      {
        player: "Hunter Shepard",
        salary2025: "$775,000",
      },
    ],
  },
  {
    philadelphia_flyers: [
      {
        player: "Luke Glendening",
        salary2025: "$775,000",
      },
      {
        player: "Travis Konecny",
        salary2025: "$8,750,000",
      },
      {
        player: "Sean Couturier",
        salary2025: "$7,750,000",
      },
      {
        player: "Owen Tippett",
        salary2025: "$6,200,000",
      },
      {
        player: "Trevor Zegras",
        salary2025: "$5,750,000",
      },
      {
        player: "Christian Dvorak",
        salary2025: "$5,400,000",
      },
      {
        player: "Noah Cates",
        salary2025: "$4,000,000",
      },
      {
        player: "Tyson Foerster",
        salary2025: "$3,750,000",
      },
      {
        player: "Garnet Hathaway",
        salary2025: "$2,400,000",
      },
      {
        player: "Carl Grundstrom",
        salary2025: "$1,800,000",
      },
      {
        player: "Matvei Michkov",
        salary2025: "$950,000",
      },
      {
        player: "Denver Barkey",
        salary2025: "$881,667",
      },
      {
        player: "Nikita Grebenkin",
        salary2025: "$875,000",
      },
      {
        player: "Rodrigo Abols",
        salary2025: "$800,000",
      },
      {
        player: "Travis Sanheim",
        salary2025: "$6,250,000",
      },
      {
        player: "Cam York",
        salary2025: "$5,150,000",
      },
      {
        player: "Rasmus Ristolainen",
        salary2025: "$5,100,000",
      },
      {
        player: "Nick Seeler",
        salary2025: "$2,700,000",
      },
      {
        player: "Jamie Drysdale",
        salary2025: "$2,300,000",
      },
      {
        player: "Emil Andrae",
        salary2025: "$903,333",
      },
      {
        player: "Noah Juulsen",
        salary2025: "$900,000",
      },
      {
        player: "Dan Vladar",
        salary2025: "$3,350,000",
      },
      {
        player: "Samuel Ersson",
        salary2025: "$1,450,000",
      },
      {
        player: "Aleksei Kolosov",
        salary2025: "$925,000",
      },
      {
        player: "Kevin Hayes",
        salary2025: "$3,571,428",
      },
      {
        player: "Cam Atkinson",
        salary2025: "$1,758,333",
      },
      {
        player: "Karsen Dorwart",
        salary2025: "$975,000",
      },
      {
        player: "Alex Bump",
        salary2025: "$950,000",
      },
      {
        player: "Jett Luchanko",
        salary2025: "$942,500",
      },
      {
        player: "Massimo Rizzo",
        salary2025: "$925,000",
      },
      {
        player: "Devin Kaplan",
        salary2025: "$921,667",
      },
      {
        player: "Jacob Gaucher",
        salary2025: "$872,500",
      },
      {
        player: "Tucker Robertson",
        salary2025: "$870,000",
      },
      {
        player: "Alexis Gendron",
        salary2025: "$860,000",
      },
      {
        player: "Oscar Eklind",
        salary2025: "$800,000",
      },
      {
        player: "Anthony Richard",
        salary2025: "$775,000",
      },
      {
        player: "Lane Pederson",
        salary2025: "$775,000",
      },
      {
        player: "Philip Tomasino",
        salary2025: "$600,000",
      },
      {
        player: "Hunter McDonald",
        salary2025: "$950,000",
      },
      {
        player: "Spencer Gill",
        salary2025: "$890,000",
      },
      {
        player: "Oliver Bonk",
        salary2025: "$886,667",
      },
      {
        player: "Christian Kyrou",
        salary2025: "$878,333",
      },
      {
        player: "Artem Guryev",
        salary2025: "$860,000",
      },
      {
        player: "Ty Murchison",
        salary2025: "$860,000",
      },
      {
        player: "Roman Schmidt",
        salary2025: "$805,833",
      },
      {
        player: "Helge Grans",
        salary2025: "$787,500",
      },
      {
        player: "Adam Ginning",
        salary2025: "$787,500",
      },
      {
        player: "Maxence Guenette",
        salary2025: "$775,000",
      },
      {
        player: "Carson Bjarnason",
        salary2025: "$850,000",
      },
    ],
  },
  {
    pittsburgh_penguins: [
      {
        player: "Samuel Girard",
        salary2025: "$5,000,000",
      },

      {
        player: "Ilya Solovyov",
        salary2025: "$775,000",
      },

      {
        player: "Sidney Crosby",
        salary2025: "$8,700,000",
      },
      {
        player: "Evgeni Malkin",
        salary2025: "$6,100,000",
      },
      {
        player: "Bryan Rust",
        salary2025: "$5,125,000",
      },
      {
        player: "Rickard Rakell",
        salary2025: "$5,000,000",
      },
      {
        player: "Kevin Hayes",
        salary2025: "$3,571,429",
      },
      {
        player: "Tommy Novak",
        salary2025: "$3,500,000",
      },
      {
        player: "Anthony Mantha",
        salary2025: "$2,500,000",
      },
      {
        player: "Egor Chinakhov",
        salary2025: "$2,100,000",
      },
      {
        player: "Noel Acciari",
        salary2025: "$2,000,000",
      },
      {
        player: "Blake Lizotte",
        salary2025: "$1,850,000",
      },
      {
        player: "Justin Brazeau",
        salary2025: "$1,500,000",
      },
      {
        player: "Connor Dewar",
        salary2025: "$1,100,000",
      },
      {
        player: "Ben Kindel",
        salary2025: "$975,000",
      },
      {
        player: "Rutger McGroarty",
        salary2025: "$950,000",
      },
      {
        player: "Tanner Howe",
        salary2025: "$845,833",
      },
      {
        player: "Filip Hallander",
        salary2025: "$775,000",
      },
      {
        player: "Erik Karlsson",
        salary2025: "$10,000,000",
      },
      {
        player: "Kris Letang",
        salary2025: "$6,100,000",
      },
      {
        player: "Ryan Graves",
        salary2025: "$4,500,000",
      },
      {
        player: "Connor Clifton",
        salary2025: "$3,333,333",
      },
      {
        player: "Parker Wotherspoon",
        salary2025: "$1,000,000",
      },
      {
        player: "Ryan Shea",
        salary2025: "$900,000",
      },
      {
        player: "Jack St. Ivany",
        salary2025: "$775,000",
      },
      {
        player: "Stuart Skinner",
        salary2025: "$2,600,000",
      },
      {
        player: "Arturs Silovs",
        salary2025: "$850,000",
      },
      {
        player: "Jack Johnson",
        salary2025: "$916,667",
      },
      {
        player: "Mathew Dumba",
        salary2025: "$2,600,000",
      },
      {
        player: "Tristan Broz",
        salary2025: "$925,000",
      },
      {
        player: "Melvin Fernstrom",
        salary2025: "$872,500",
      },
      {
        player: "Mikhail Ilyin",
        salary2025: "$851,667",
      },
      {
        player: "Avery Hayes",
        salary2025: "$830,000",
      },
      {
        player: "Ville Koivunen",
        salary2025: "$805,833",
      },
      {
        player: "Valtteri Puustinen",
        salary2025: "$775,000",
      },
      {
        player: "Joona Koppanen",
        salary2025: "$775,000",
      },
      {
        player: "Bokondji Imama",
        salary2025: "$775,000",
      },
      {
        player: "Rafael Harvey-Pinard",
        salary2025: "$775,000",
      },
      {
        player: "Mathew Dumba",
        salary2025: "$2,600,000",
      },
      {
        player: "Caleb Jones",
        salary2025: "$900,000",
      },
      {
        player: "Owen Pickering",
        salary2025: "$886,667",
      },
      {
        player: "Peyton Kettles",
        salary2025: "$875,000",
      },
      {
        player: "Chase Pietila",
        salary2025: "$860,000",
      },
      {
        player: "Daniel Laatsch",
        salary2025: "$860,000",
      },
      {
        player: "Finn Harding",
        salary2025: "$855,000",
      },
      {
        player: "Harrison Brunicke",
        salary2025: "$845,833",
      },
      {
        player: "Emil Pieniniemi",
        salary2025: "$806,667",
      },
      {
        player: "Philip Kemp",
        salary2025: "$775,000",
      },
      {
        player: "Sebastian Aho",
        salary2025: "$775,000",
      },
      {
        player: "Alexander Alexeyev",
        salary2025: "$775,000",
      },
      {
        player: "Joel Blomqvist",
        salary2025: "$886,667",
      },
      {
        player: "Sergey Murashov",
        salary2025: "$861,110",
      },
      {
        player: "Filip Larsson",
        salary2025: "$775,000",
      },
    ],
  },
  {
    san_jose_sharks: [
      {
        player: "Kiefer Sherwood",
        salary2025: "$1,500,000",
      },
      {
        player: "Logan Couture",
        salary2025: "$8,000,000",
      },
      {
        player: "Tyler Toffoli",
        salary2025: "$6,000,000",
      },
      {
        player: "Alexander Wennberg",
        salary2025: "$5,000,000",
      },
      {
        player: "Barclay Goodrow",
        salary2025: "$3,641,667",
      },
      {
        player: "Jeff Skinner",
        salary2025: "$3,000,000",
      },
      {
        player: "Adam Gaudette",
        salary2025: "$2,000,000",
      },
      {
        player: "Ryan Reaves",
        salary2025: "$1,350,000",
      },
      {
        player: "Ty Dellandrea",
        salary2025: "$1,300,000",
      },
      {
        player: "Philipp Kurashev",
        salary2025: "$1,200,000",
      },
      {
        player: "Macklin Celebrini",
        salary2025: "$975,000",
      },
      {
        player: "Michael Misa",
        salary2025: "$975,000",
      },
      {
        player: "Will Smith",
        salary2025: "$950,000",
      },
      {
        player: "Collin Graf",
        salary2025: "$941,667",
      },
      {
        player: "Igor Chernyshov",
        salary2025: "$934,167",
      },
      {
        player: "William Eklund",
        salary2025: "$863,333",
      },
      {
        player: "Zack Ostapchuk",
        salary2025: "$825,000",
      },
      {
        player: "Pavol Regenda",
        salary2025: "$775,000",
      },
      {
        player: "Dmitry Orlov",
        salary2025: "$6,500,000",
      },
      {
        player: "John Klingberg",
        salary2025: "$4,000,000",
      },
      {
        player: "Nick Leddy",
        salary2025: "$4,000,000",
      },
      {
        player: "Mario Ferraro",
        salary2025: "$3,250,000",
      },
      {
        player: "Vincent Desharnais",
        salary2025: "$2,000,000",
      },
      {
        player: "Shakir Mukhamadullin",
        salary2025: "$1,000,000",
      },
      {
        player: "Sam Dickinson",
        salary2025: "$942,500",
      },

      {
        player: "Alex Nedeljkovic",
        salary2025: "$2,500,000",
      },
      {
        player: "Yaroslav Askarov",
        salary2025: "$2,000,000",
      },
      {
        player: "Carey Price",
        salary2025: "$10,500,000",
      },
      {
        player: "Erik Karlsson",
        salary2025: "$1,500,000",
      },
      {
        player: "Tomas Hertl",
        salary2025: "$1,387,500",
      },
      {
        player: "Marc-Edouard Vlasic",
        salary2025: "$4,666,667",
      },
      {
        player: "Martin Jones",
        salary2025: "$1,666,667",
      },
      {
        player: "Laurent Brossoit",
        salary2025: "$2,150,000",
      },
      {
        player: "Cameron Lund",
        salary2025: "$941,667",
      },
      {
        player: "Filip Bystedt",
        salary2025: "$918,333",
      },
      {
        player: "Quentin Musty",
        salary2025: "$886,667",
      },
      {
        player: "Kasper Halttunen",
        salary2025: "$876,667",
      },
      {
        player: "Ethan Cardwell",
        salary2025: "$867,500",
      },
      {
        player: "Egor Afanasyev",
        salary2025: "$800,000",
      },
      {
        player: "Jimmy Huntington",
        salary2025: "$775,000",
      },
      {
        player: "Samuel Laberge",
        salary2025: "$775,000",
      },
      {
        player: "Shane Bowers",
        salary2025: "$775,000",
      },
      {
        player: "Colin White",
        salary2025: "$775,000",
      },
      {
        player: "Patrick Giles",
        salary2025: "$775,000",
      },
      {
        player: "Noah Beck",
        salary2025: "$975,000",
      },
      {
        player: "Leo Sahlin Wallenius",
        salary2025: "$940,000",
      },
      {
        player: "Mattias Havelid",
        salary2025: "$905,000",
      },
      {
        player: "Luca Cagnoni",
        salary2025: "$895,000",
      },
      {
        player: "Nolan Allan",
        salary2025: "$825,000",
      },
      {
        player: "Lucas Carlsson",
        salary2025: "$800,000",
      },
      {
        player: "Jack Thompson",
        salary2025: "$800,000",
      },
      {
        player: "Cole Clayton",
        salary2025: "$775,000",
      },
      {
        player: "Laurent Brossoit",
        salary2025: "$2,150,000",
      },
      {
        player: "Gabriel Carriere",
        salary2025: "$795,000",
      },
      {
        player: "Jakub Skarek",
        salary2025: "$775,000",
      },
    ],
  },
  {
    seattle_kraken: [
      {
        player: "Bobby McMann",
        salary2025: "$1,350,000",
      },

      {
        player: "Matty Beniers",
        salary2025: "$7,142,857",
      },
      {
        player: "Chandler Stephenson",
        salary2025: "$6,250,000",
      },
      {
        player: "Jaden Schwartz",
        salary2025: "$5,500,000",
      },
      {
        player: "Jared McCann",
        salary2025: "$5,000,000",
      },
      {
        player: "Jordan Eberle",
        salary2025: "$4,750,000",
      },
      {
        player: "Kaapo Kakko",
        salary2025: "$4,525,000",
      },
      {
        player: "Eeli Tolvanen",
        salary2025: "$3,475,000",
      },
      {
        player: "Frederick Gaudreau",
        salary2025: "$2,100,000",
      },
      {
        player: "Berkly Catton",
        salary2025: "$942,500",
      },
      {
        player: "Shane Wright",
        salary2025: "$886,667",
      },
      {
        player: "Ryan Winterton",
        salary2025: "$828,333",
      },
      {
        player: "Max McCormick",
        salary2025: "$775,000",
      },
      {
        player: "Ben Meyers",
        salary2025: "$775,000",
      },
      {
        player: "Vince Dunn",
        salary2025: "$7,350,000",
      },
      {
        player: "Brandon Montour",
        salary2025: "$7,142,857",
      },
      {
        player: "Adam Larsson",
        salary2025: "$5,250,000",
      },
      {
        player: "Jamie Oleksiak",
        salary2025: "$4,600,000",
      },
      {
        player: "Ryan Lindgren",
        salary2025: "$4,500,000",
      },
      {
        player: "Ryker Evans",
        salary2025: "$2,050,000",
      },
      {
        player: "Joshua Mahura",
        salary2025: "$907,500",
      },
      {
        player: "Cale Fleury",
        salary2025: "$890,000",
      },
      {
        player: "Philipp Grubauer",
        salary2025: "$5,900,000",
      },
      {
        player: "Joey Daccord",
        salary2025: "$5,000,000",
      },
      {
        player: "Matt Murray",
        salary2025: "$1,000,000",
      },
      {
        player: "Joe Veleno",
        salary2025: "$795,833",
      },
      {
        player: "Jake O'Brien",
        salary2025: "$975,000",
      },
      {
        player: "Nathan Villeneuve",
        salary2025: "$940,833",
      },
      {
        player: "Julius Miettinen",
        salary2025: "$940,833",
      },
      {
        player: "Carson Rehkopf",
        salary2025: "$891,667",
      },
      {
        player: "Jagger Firkus",
        salary2025: "$891,667",
      },
      {
        player: "David Goyette",
        salary2025: "$891,667",
      },
      {
        player: "Jani Nyman",
        salary2025: "$891,667",
      },
      {
        player: "Oscar Fisker Molgaard",
        salary2025: "$891,667",
      },
      {
        player: "Eduard Sale",
        salary2025: "$886,667",
      },
      {
        player: "Logan Morrison",
        salary2025: "$870,000",
      },
      {
        player: "Andrei Loshko",
        salary2025: "$870,000",
      },
      {
        player: "Lleyton Roed",
        salary2025: "$870,000",
      },
      {
        player: "Jacob Melanson",
        salary2025: "$826,111",
      },
      {
        player: "Jon-Randall Avon",
        salary2025: "$800,000",
      },
      {
        player: "Mitchell Stephens",
        salary2025: "$775,000",
      },
      {
        player: "John Hayden",
        salary2025: "$775,000",
      },
      {
        player: "Tyson Jugnauth",
        salary2025: "$950,000",
      },
      {
        player: "Lukas Dragicevic",
        salary2025: "$891,667",
      },
      {
        player: "Ville Ottavainen",
        salary2025: "$867,500",
      },
      {
        player: "Kaden Hammell",
        salary2025: "$865,833",
      },
      {
        player: "Ty Nelson",
        salary2025: "$836,667",
      },
      {
        player: "Caden Price",
        salary2025: "$835,833",
      },
      {
        player: "Niklas Kokko",
        salary2025: "$891,667",
      },
      {
        player: "Victor Ostman",
        salary2025: "$870,000",
      },
      {
        player: "Kim Saarinen",
        salary2025: "$840,000",
      },
    ],
  },
  {
    st_louis_blues: [
      {
        player: "Justin Holl",
        salary2025: "$2,250,000",
      },

      {
        player: "Jonathan Drouin",
        salary2025: "$4,000,000",
      },
      {
        player: "Jack Finley",
        salary2025: "$775,000",
      },

      {
        player: "Jordan Kyrou",
        salary2025: "$8,125,000",
      },
      {
        player: "Robert Thomas",
        salary2025: "$8,125,000",
      },
      {
        player: "Pavel Buchnevich",
        salary2025: "$8,000,000",
      },
      {
        player: "Pius Suter",
        salary2025: "$4,125,000",
      },
      {
        player: "Jake Neighbours",
        salary2025: "$3,750,000",
      },
      {
        player: "Dylan Holloway",
        salary2025: "$2,290,457",
      },
      {
        player: "Jonatan Berggren",
        salary2025: "$1,825,000",
      },

      {
        player: "Alexey Toropchenko",
        salary2025: "$1,700,000",
      },
      {
        player: "Oskar Sundqvist",
        salary2025: "$1,500,000",
      },
      {
        player: "Jimmy Snuggerud",
        salary2025: "$950,000",
      },
      {
        player: "Otto Stenberg",
        salary2025: "$918,333",
      },
      {
        player: "Dalibor Dvorsky",
        salary2025: "$886,667",
      },
      {
        player: "Nathan Walker",
        salary2025: "$775,000",
      },
      {
        player: "Colton Parayko",
        salary2025: "$6,500,000",
      },
      {
        player: "Philip Broberg",
        salary2025: "$4,580,917",
      },
      {
        player: "Cam Fowler",
        salary2025: "$4,000,000",
      },
      {
        player: "Tyler Tucker",
        salary2025: "$925,000",
      },
      {
        player: "Logan Mailloux",
        salary2025: "$875,000",
      },
      {
        player: "Matthew Kessel",
        salary2025: "$800,000",
      },
      {
        player: "Jordan Binnington",
        salary2025: "$6,000,000",
      },
      {
        player: "Joel Hofer",
        salary2025: "$3,400,000",
      },
      {
        player: "Torey Krug",
        salary2025: "$3,817,293",
      },
      {
        player: "Torey Krug",
        salary2025: "$2,682,707",
      },
      {
        player: "Justin Carbonneau",
        salary2025: "$975,000",
      },
      {
        player: "Adam Jecho",
        salary2025: "$872,500",
      },
      {
        player: "Aleksanteri Kaskimaki",
        salary2025: "$870,000",
      },
      {
        player: "Dylan Peterson",
        salary2025: "$867,500",
      },
      {
        player: "Simon Robertsson",
        salary2025: "$867,500",
      },
      {
        player: "Nikita Susuyev",
        salary2025: "$855,000",
      },
      {
        player: "Zach Dean",
        salary2025: "$852,500",
      },
      {
        player: "Juraj Pekarcik",
        salary2025: "$838,333",
      },
      {
        player: "Jakub Stancl",
        salary2025: "$835,000",
      },
      {
        player: "Akil Thomas",
        salary2025: "$775,000",
      },
      {
        player: "Hugh McGing",
        salary2025: "$775,000",
      },
      {
        player: "Matt Luff",
        salary2025: "$775,000",
      },
      {
        player: "Adam Jiricek",
        salary2025: "$942,500",
      },
      {
        player: "Lukas Fischer",
        salary2025: "$931,667",
      },
      {
        player: "Theo Lindstein",
        salary2025: "$918,333",
      },
      {
        player: "Samuel Johannesson",
        salary2025: "$870,000",
      },
      {
        player: "Leo Loof",
        salary2025: "$867,500",
      },
      {
        player: "Michael Buchinger",
        salary2025: "$838,333",
      },
      {
        player: "Quinton Burns",
        salary2025: "$838,333",
      },
      {
        player: "Marc-Andre Gaudet",
        salary2025: "$802,500",
      },
      {
        player: "Calle Rosen",
        salary2025: "$775,000",
      },
      {
        player: "Hunter Skinner",
        salary2025: "$775,000",
      },
      {
        player: "Vadim Zherenko",
        salary2025: "$775,000",
      },
      {
        player: "Will Cranley",
        salary2025: "$775,000",
      },
      {
        player: "Georgi Romanov",
        salary2025: "$775,000",
      },
    ],
  },
  {
    tampa_bay_lightning: [
      {
        player: "Corey Perry",
        salary2025: "$2,000,000",
      },

      {
        player: "Nikita Kucherov",
        salary2025: "$9,500,000",
      },
      {
        player: "Brayden Point",
        salary2025: "$9,500,000",
      },
      {
        player: "Jake Guentzel",
        salary2025: "$9,000,000",
      },
      {
        player: "Brandon Hagel",
        salary2025: "$6,500,000",
      },
      {
        player: "Anthony Cirelli",
        salary2025: "$6,250,000",
      },
      {
        player: "Oliver Bjorkstrand",
        salary2025: "$5,400,000",
      },
      {
        player: "Nick Paul",
        salary2025: "$3,150,000",
      },
      {
        player: "Yanni Gourde",
        salary2025: "$2,333,333",
      },
      {
        player: "Pontus Holmberg",
        salary2025: "$1,550,000",
      },
      {
        player: "Gage Goncalves",
        salary2025: "$1,200,000",
      },
      {
        player: "Dominic James",
        salary2025: "$910,000",
      },
      {
        player: "Zemgus Girgensons",
        salary2025: "$850,000",
      },
      {
        player: "Scott Sabourin",
        salary2025: "$775,000",
      },
      {
        player: "Victor Hedman",
        salary2025: "$8,000,000",
      },
      {
        player: "Ryan McDonagh",
        salary2025: "$6,750,000",
      },
      {
        player: "Erik Cernak",
        salary2025: "$5,200,000",
      },
      {
        player: "J.J. Moser",
        salary2025: "$3,375,000",
      },
      {
        player: "Darren Raddysh",
        salary2025: "$975,000",
      },
      {
        player: "Emil Lilleberg",
        salary2025: "$800,000",
      },
      {
        player: "Max Crozier",
        salary2025: "$775,000",
      },
      {
        player: "Charle-Edouard D'Astous",
        salary2025: "$775,000",
      },
      {
        player: "Declan Carlile",
        salary2025: "$775,000",
      },
      {
        player: "Simon Lundmark",
        salary2025: "$775,000",
      },
      {
        player: "Andrei Vasilevskiy",
        salary2025: "$9,500,000",
      },
      {
        player: "Jonas Johansson",
        salary2025: "$1,250,000",
      },
      {
        player: "Brandon Halverson",
        salary2025: "$775,000",
      },
      {
        player: "Ethan Czata",
        salary2025: "$931,667",
      },
      {
        player: "Sam O'Reilly",
        salary2025: "$931,500",
      },
      {
        player: "Lucas Mercuri",
        salary2025: "$896,250",
      },
      {
        player: "Conor Geekie",
        salary2025: "$886,667",
      },
      {
        player: "Milo Roelens",
        salary2025: "$870,000",
      },
      {
        player: "Gabriel Szturc",
        salary2025: "$870,000",
      },
      {
        player: "Connor Kurth",
        salary2025: "$870,000",
      },
      {
        player: "Dylan Duke",
        salary2025: "$867,500",
      },
      {
        player: "Cooper Flinton",
        salary2025: "$867,500",
      },
      {
        player: "Maxim Groshev",
        salary2025: "$867,500",
      },
      {
        player: "Tristan Allard",
        salary2025: "$860,000",
      },
      {
        player: "Ethan Gauthier",
        salary2025: "$833,333",
      },
      {
        player: "Mitchell Chaffee",
        salary2025: "$800,000",
      },
      {
        player: "Wojciech Stachowiak",
        salary2025: "$775,000",
      },
      {
        player: "Nick Abruzzese",
        salary2025: "$775,000",
      },
      {
        player: "Jakob Pelletier",
        salary2025: "$775,000",
      },
      {
        player: "Michael Milne",
        salary2025: "$775,000",
      },
      {
        player: "Dyllan Gill",
        salary2025: "$870,000",
      },
      {
        player: "Ethan Samson",
        salary2025: "$846,667",
      },
      {
        player: "Steven Santini",
        salary2025: "$775,000",
      },
      {
        player: "Harrison Meneghin",
        salary2025: "$872,500",
      },
      {
        player: "Ryan Fanti",
        salary2025: "$775,000",
      },
    ],
  },
  {
    toronto_maple_leafs: [
      {
        player: "Auston Matthews",
        salary2025: "$13,250,000",
      },
      {
        player: "William Nylander",
        salary2025: "$11,500,000",
      },
      {
        player: "Matthew Knies",
        salary2025: "$7,750,000",
      },
      {
        player: "John Tavares",
        salary2025: "$4,380,000",
      },
      {
        player: "Max Domi",
        salary2025: "$3,750,000",
      },
      {
        player: "Matias Maccelli",
        salary2025: "$3,425,000",
      },
      {
        player: "Dakota Joshua",
        salary2025: "$3,250,000",
      },
      {
        player: "Calle Jarnkrok",
        salary2025: "$2,100,000",
      },
      {
        player: "Nicholas Robertson",
        salary2025: "$1,825,000",
      },
      {
        player: "Scott Laughton",
        salary2025: "$1,500,000",
      },
      {
        player: "Steven Lorentz",
        salary2025: "$1,350,000",
      },
      {
        player: "Easton Cowan",
        salary2025: "$873,500",
      },
      {
        player: "Morgan Rielly",
        salary2025: "$7,500,000",
      },
      {
        player: "Chris Tanev",
        salary2025: "$4,500,000",
      },
      {
        player: "Jake McCabe",
        salary2025: "$4,491,898",
      },
      {
        player: "Oliver Ekman-Larsson",
        salary2025: "$3,500,000",
      },
      {
        player: "Brandon Carlo",
        salary2025: "$3,485,000",
      },
      {
        player: "Simon Benoit",
        salary2025: "$1,350,000",
      },
      {
        player: "Matt Benning",
        salary2025: "$1,250,000",
      },
      {
        player: "Philippe Myers",
        salary2025: "$850,000",
      },
      {
        player: "Troy Stecher",
        salary2025: "$787,500",
      },
      {
        player: "Joseph Woll",
        salary2025: "$3,666,667",
      },
      {
        player: "Anthony Stolarz",
        salary2025: "$2,500,000",
      },
      {
        player: "Dennis Hildeby",
        salary2025: "$841,667",
      },
      {
        player: "Miroslav Holinka",
        salary2025: "$918,333",
      },
      {
        player: "Luke Haymes",
        salary2025: "$875,000",
      },
      {
        player: "Jacob Quillan",
        salary2025: "$875,000",
      },
      {
        player: "Borya Valis",
        salary2025: "$872,500",
      },
      {
        player: "Ryan Tverberg",
        salary2025: "$851,667",
      },
      {
        player: "Bo Groulx",
        salary2025: "$812,500",
      },
      {
        player: "Michael Pezzetta",
        salary2025: "$812,500",
      },
      {
        player: "Braeden Kressler",
        salary2025: "$800,556",
      },
      {
        player: "Travis Boyd",
        salary2025: "$775,000",
      },
      {
        player: "Vinni Lettieri",
        salary2025: "$775,000",
      },
      {
        player: "Henry Thrun",
        salary2025: "$1,000,000",
      },
      {
        player: "Ben Danford",
        salary2025: "$931,500",
      },
      {
        player: "Blake Smith",
        salary2025: "$875,000",
      },
      {
        player: "John Prokop",
        salary2025: "$875,000",
      },
      {
        player: "Cade Webber",
        salary2025: "$825,000",
      },
      {
        player: "Dakota Mermis",
        salary2025: "$812,500",
      },
      {
        player: "Noah Chadwick",
        salary2025: "$800,000",
      },
      {
        player: "William Villeneuve",
        salary2025: "$775,000",
      },
      {
        player: "Marshall Rifai",
        salary2025: "$775,000",
      },
      {
        player: "Vyacheslav Peksa",
        salary2025: "$851,667",
      },
      {
        player: "Artur Akhtyamov",
        salary2025: "$851,667",
      },
    ],
  },
  {
    utah_mammoth: [
      {
        player: "MacKenzie Weegar",
        salary2025: "$6,250,000",
      },

      {
        player: "JJ Peterka",
        salary2025: "$7,700,000",
      },
      {
        player: "Clayton Keller",
        salary2025: "$7,150,000",
      },
      {
        player: "Dylan Guenther",
        salary2025: "$7,142,857",
      },
      {
        player: "Nick Schmaltz",
        salary2025: "$5,850,000",
      },
      {
        player: "Lawson Crouse",
        salary2025: "$4,300,000",
      },
      {
        player: "Jack McBain",
        salary2025: "$4,250,000",
      },
      {
        player: "Alexander Kerfoot",
        salary2025: "$3,000,000",
      },
      {
        player: "Barrett Hayton",
        salary2025: "$2,650,000",
      },
      {
        player: "Brandon Tanev",
        salary2025: "$2,500,000",
      },
      {
        player: "Kevin Stenlund",
        salary2025: "$2,000,000",
      },
      {
        player: "Liam O'Brien",
        salary2025: "$1,000,000",
      },
      {
        player: "Logan Cooley",
        salary2025: "$950,000",
      },
      {
        player: "Danil But",
        salary2025: "$950,000",
      },
      {
        player: "Michael Carcone",
        salary2025: "$775,000",
      },
      {
        player: "Kailer Yamamoto",
        salary2025: "$775,000",
      },
      {
        player: "Kevin Rooney",
        salary2025: "$775,000",
      },
      {
        player: "Mikhail Sergachev",
        salary2025: "$8,500,000",
      },
      {
        player: "Sean Durzi",
        salary2025: "$6,000,000",
      },
      {
        player: "John Marino",
        salary2025: "$4,400,000",
      },
      {
        player: "Nate Schmidt",
        salary2025: "$3,500,000",
      },
      {
        player: "Ian Cole",
        salary2025: "$2,800,000",
      },
      {
        player: "Nick DeSimone",
        salary2025: "$800,000",
      },
      {
        player: "Karel Vejmelka",
        salary2025: "$4,750,000",
      },
      {
        player: "Vitek Vanecek",
        salary2025: "$1,500,000",
      },
      {
        player: "Anson Thornton",
        salary2025: "$795,556",
      },
      {
        player: "Connor Ingram",
        salary2025: "$799,500",
      },
      {
        player: "Oliver Ekman-Larsson",
        salary2025: "$650,000",
      },
      {
        player: "Tij Iginla",
        salary2025: "$942,500",
      },
      {
        player: "Cole Beaudoin",
        salary2025: "$942,500",
      },
      {
        player: "Julian Lutz",
        salary2025: "$923,333",
      },
      {
        player: "Miko Matikka",
        salary2025: "$870,000",
      },
      {
        player: "Owen Allard",
        salary2025: "$869,167",
      },
      {
        player: "Gabe Smith",
        salary2025: "$869,167",
      },
      {
        player: "Michal Kunc",
        salary2025: "$861,000",
      },
      {
        player: "Sam Lipkin",
        salary2025: "$851,667",
      },
      {
        player: "Noel Nordh",
        salary2025: "$835,000",
      },
      {
        player: "Cameron Hebig",
        salary2025: "$812,500",
      },
      {
        player: "Ben McCartney",
        salary2025: "$775,000",
      },
      {
        player: "Andrew Agozzino",
        salary2025: "$775,000",
      },
      {
        player: "Artem Duda",
        salary2025: "$950,000",
      },
      {
        player: "Dmitriy Simashev",
        salary2025: "$950,000",
      },
      {
        player: "Maveric Lamoureux",
        salary2025: "$886,667",
      },
      {
        player: "Tomas Lavoie",
        salary2025: "$872,500",
      },
      {
        player: "Maksymilian Szuber",
        salary2025: "$859,167",
      },
      {
        player: "Terrell Goldsmith",
        salary2025: "$838,333",
      },
      {
        player: "Montana Onyebuchi",
        salary2025: "$775,000",
      },
      {
        player: "Scott Perunovich",
        salary2025: "$775,000",
      },
      {
        player: "Kevin Connauton",
        salary2025: "$775,000",
      },
      {
        player: "Jaxson Stauber",
        salary2025: "$775,000",
      },
      {
        player: "Matt Villalta",
        salary2025: "$775,000",
      },
    ],
  },
  {
    vancouver_canucks: [
      {
        player: "Curtis Douglas",
        salary2025: "$775,000",
      },
      {
        player: "Elias Pettersson",
        salary2025: "$11,600,000",
      },
      {
        player: "Brock Boeser",
        salary2025: "$7,250,000",
      },
      {
        player: "Jake DeBrusk",
        salary2025: "$5,500,000",
      },
      {
        player: "Evander Kane",
        salary2025: "$5,125,000",
      },
      {
        player: "Marco Rossi",
        salary2025: "$5,000,000",
      },
      {
        player: "Filip Chytil",
        salary2025: "$4,437,500",
      },
      {
        player: "Nils Hoglander",
        salary2025: "$3,000,000",
      },
      {
        player: "Drew O'Connor",
        salary2025: "$2,500,000",
      },
      {
        player: "Teddy Blueger",
        salary2025: "$1,800,000",
      },

      {
        player: "David Kampf",
        salary2025: "$1,100,000",
      },
      {
        player: "Liam Ohgren",
        salary2025: "$886,667",
      },
      {
        player: "Aatu Raty",
        salary2025: "$775,000",
      },
      {
        player: "Linus Karlsson",
        salary2025: "$775,000",
      },
      {
        player: "Max Sasson",
        salary2025: "$775,000",
      },
      {
        player: "Arshdeep Bains",
        salary2025: "$775,000",
      },
      {
        player: "Filip Hronek",
        salary2025: "$7,250,000",
      },
      {
        player: "Marcus Pettersson",
        salary2025: "$5,500,000",
      },
      {
        player: "Zeev Buium",
        salary2025: "$966,500",
      },
      {
        player: "Tom Willander",
        salary2025: "$950,000",
      },
      {
        player: "Victor Mancini",
        salary2025: "$870,000",
      },
      {
        player: "Pierre-Olivier Joseph",
        salary2025: "$775,000",
      },
      {
        player: "Guillaume Brisebois",
        salary2025: "$775,000",
      },
      {
        player: "Thatcher Demko",
        salary2025: "$5,000,000",
      },
      {
        player: "Kevin Lankinen",
        salary2025: "$4,500,000",
      },
      {
        player: "Nikita Tolopilo",
        salary2025: "$775,000",
      },
      {
        player: "Derek Forbort",
        salary2025: "$2,000,000",
      },
      {
        player: "Ilya Mikheyev",
        salary2025: "$712,500",
      },
      {
        player: "Oliver Ekman-Larsson",
        salary2025: "$4,766,667",
      },
      {
        player: "Lukas Reichel",
        salary2025: "$50,000",
      },
      {
        player: "Braeden Cootes",
        salary2025: "$975,000",
      },
      {
        player: "Riley Patterson",
        salary2025: "$923,333",
      },
      {
        player: "Jonathan Lekkerimaki",
        salary2025: "$918,333",
      },
      {
        player: "Gabe Chiarot",
        salary2025: "$916,667",
      },
      {
        player: "Anri Ravinskis",
        salary2025: "$872,500",
      },
      {
        player: "Ty Mueller",
        salary2025: "$870,000",
      },
      {
        player: "Chase Stillman",
        salary2025: "$863,333",
      },
      {
        player: "Josh Bloom",
        salary2025: "$836,667",
      },
      {
        player: "Danila Klimovich",
        salary2025: "$833,333",
      },
      {
        player: "Vilmer Alriksson",
        salary2025: "$831,667",
      },
      {
        player: "Nils Aman",
        salary2025: "$825,000",
      },
      {
        player: "Joseph LaBate",
        salary2025: "$775,000",
      },
      {
        player: "Mackenzie MacEachern",
        salary2025: "$775,000",
      },
      {
        player: "Lukas Reichel",
        salary2025: "$50,000",
      },
      {
        player: "Elias Pettersson",
        salary2025: "$838,333",
      },
      {
        player: "Kirill Kudryavtsev",
        salary2025: "$825,000",
      },
      {
        player: "Sawyer Mynio",
        salary2025: "$806,667",
      },
      {
        player: "Jimmy Schuldt",
        salary2025: "$775,000",
      },
      {
        player: "Jett Woo",
        salary2025: "$775,000",
      },
      {
        player: "Alexei Medvedev",
        salary2025: "$923,333",
      },
      {
        player: "Aku Koskenvuo",
        salary2025: "$850,000",
      },
      {
        player: "Ty Young",
        salary2025: "$825,000",
      },
      {
        player: "Jiri Patera",
        salary2025: "$775,000",
      },
    ],
  },
  {
    vegas_golden_knights: [
      {
        player: "Rasmus Sandin",
        salary2025: "$4,600,000",
      },

      {
        player: "Cole Smith",
        salary2025: "$1,000,000",
      },

      {
        player: "Nic Dowd",
        salary2025: "$3,000,000",
      },

      {
        player: "Mitch Marner",
        salary2025: "$12,000,000",
      },
      {
        player: "Jack Eichel",
        salary2025: "$10,000,000",
      },
      {
        player: "Mark Stone",
        salary2025: "$9,500,000",
      },
      {
        player: "Tomas Hertl",
        salary2025: "$6,750,000",
      },
      {
        player: "Ivan Barbashev",
        salary2025: "$5,000,000",
      },
      {
        player: "Brett Howden",
        salary2025: "$2,500,000",
      },
      {
        player: "Keegan Kolesar",
        salary2025: "$2,500,000",
      },
      {
        player: "Brandon Saad",
        salary2025: "$2,000,000",
      },
      {
        player: "Reilly Smith",
        salary2025: "$2,000,000",
      },
      {
        player: "Pavel Dorofeyev",
        salary2025: "$1,835,000",
      },
      {
        player: "Colton Sissons",
        salary2025: "$1,428,572",
      },
      {
        player: "Alexander Holtz",
        salary2025: "$837,500",
      },
      {
        player: "Braeden Bowman",
        salary2025: "$837,500",
      },
      {
        player: "Tanner Laczynski",
        salary2025: "$775,000",
      },
      {
        player: "Shea Theodore",
        salary2025: "$7,425,000",
      },
      {
        player: "Noah Hanifin",
        salary2025: "$7,350,000",
      },
      {
        player: "Brayden McNabb",
        salary2025: "$3,650,000",
      },
      {
        player: "Jeremy Lauzon",
        salary2025: "$2,000,000",
      },
      {
        player: "Ben Hutton",
        salary2025: "$975,000",
      },
      {
        player: "Kaedan Korczak",
        salary2025: "$825,000",
      },
      {
        player: "Adin Hill",
        salary2025: "$6,250,000",
      },
      {
        player: "Carter Hart",
        salary2025: "$2,000,000",
      },
      {
        player: "Akira Schmid",
        salary2025: "$875,000",
      },
      {
        player: "Alex Pietrangelo",
        salary2025: "$8,800,000",
      },
      {
        player: "William Karlsson",
        salary2025: "$3,817,293",
      },
      {
        player: "William Karlsson",
        salary2025: "$2,082,707",
      },
      {
        player: "Trevor Connelly",
        salary2025: "$975,000",
      },
      {
        player: "Jackson Hallum",
        salary2025: "$925,000",
      },
      {
        player: "Tuomas Uronen",
        salary2025: "$852,500",
      },
      {
        player: "Jakub Demek",
        salary2025: "$851,683",
      },
      {
        player: "Trent Swick",
        salary2025: "$850,000",
      },
      {
        player: "Kai Uchacz",
        salary2025: "$845,000",
      },
      {
        player: "Jordan Gustafson",
        salary2025: "$830,000",
      },
      {
        player: "Jakub Brabenec",
        salary2025: "$828,333",
      },
      {
        player: "Ben Hemmerling",
        salary2025: "$821,111",
      },
      {
        player: "Matyas Sapovaliv",
        salary2025: "$803,333",
      },
      {
        player: "Mathieu Cataford",
        salary2025: "$801,667",
      },
      {
        player: "Raphael Lavoie",
        salary2025: "$775,000",
      },
      {
        player: "Jonas Rondbjerg",
        salary2025: "$775,000",
      },
      {
        player: "Jeremy Davies",
        salary2025: "$1,150,000",
      },
      {
        player: "Christoffer Sedoff",
        salary2025: "$870,000",
      },
      {
        player: "Joe Fleming",
        salary2025: "$836,667",
      },
      {
        player: "Viliam Kmec",
        salary2025: "$833,333",
      },
      {
        player: "Jaycob Megna",
        salary2025: "$800,000",
      },
      {
        player: "Lukas Cormier",
        salary2025: "$775,000",
      },
      {
        player: "Dylan Coghlan",
        salary2025: "$775,000",
      },
      {
        player: "Cameron Whitehead",
        salary2025: "$875,000",
      },
      {
        player: "Jesper Vikman",
        salary2025: "$858,000",
      },
      {
        player: "Carl Lindbom",
        salary2025: "$840,000",
      },
    ],
  },
  {
    washington_capitals: [
      {
        player: "Timothy Liljegren",
        salary2025: "$3,000,000",
      },

      {
        player: "Alex Ovechkin",
        salary2025: "$9,500,000",
      },
      {
        player: "Pierre-Luc Dubois",
        salary2025: "$8,500,000",
      },
      {
        player: "Tom Wilson",
        salary2025: "$6,500,000",
      },
      {
        player: "Dylan Strome",
        salary2025: "$5,000,000",
      },
      {
        player: "Aliaksei Protas",
        salary2025: "$3,375,000",
      },
      {
        player: "Anthony Beauvillier",
        salary2025: "$2,750,000",
      },
      {
        player: "Connor McMichael",
        salary2025: "$2,100,000",
      },
      {
        player: "Sonny Milano",
        salary2025: "$1,900,000",
      },
      {
        player: "Brandon Duhaime",
        salary2025: "$1,850,000",
      },
      {
        player: "Ryan Leonard",
        salary2025: "$950,000",
      },
      {
        player: "Ivan Miroshnichenko",
        salary2025: "$950,000",
      },
      {
        player: "Hendrix Lapierre",
        salary2025: "$850,000",
      },
      {
        player: "Justin Sourdif",
        salary2025: "$825,000",
      },
      {
        player: "Ethen Frank",
        salary2025: "$775,000",
      },
      {
        player: "Brett Leason",
        salary2025: "$775,000",
      },
      {
        player: "Jakob Chychrun",
        salary2025: "$9,000,000",
      },
      {
        player: "Matt Roy",
        salary2025: "$5,750,000",
      },
      {
        player: "Trevor van Riemsdyk",
        salary2025: "$3,000,000",
      },
      {
        player: "Martin Fehervary",
        salary2025: "$2,675,000",
      },
      {
        player: "Declan Chisholm",
        salary2025: "$1,600,000",
      },
      {
        player: "Dylan McIlrath",
        salary2025: "$800,000",
      },
      {
        player: "Logan Thompson",
        salary2025: "$5,850,000",
      },
      {
        player: "Charlie Lindgren",
        salary2025: "$3,000,000",
      },
      {
        player: "Milton Gastrin",
        salary2025: "$975,000",
      },
      {
        player: "Lynden Lakovic",
        salary2025: "$975,000",
      },
      {
        player: "Terik Parascak",
        salary2025: "$942,500",
      },
      {
        player: "Zac Funk",
        salary2025: "$905,000",
      },
      {
        player: "Patrick Thomas",
        salary2025: "$878,333",
      },
      {
        player: "Ilya Protas",
        salary2025: "$856,667",
      },
      {
        player: "Eriks Mateiko",
        salary2025: "$856,667",
      },
      {
        player: "Ryan Hofer",
        salary2025: "$851,667",
      },
      {
        player: "Andrew Cristall",
        salary2025: "$841,667",
      },
      {
        player: "Ludwig Persson",
        salary2025: "$815,000",
      },
      {
        player: "Alexander Suzdalev",
        salary2025: "$815,000",
      },
      {
        player: "Graeme Clarke",
        salary2025: "$775,000",
      },
      {
        player: "Henrik Rybinski",
        salary2025: "$775,000",
      },
      {
        player: "Spencer Smallman",
        salary2025: "$775,000",
      },
      {
        player: "Bogdan Trineyev",
        salary2025: "$775,000",
      },
      {
        player: "Ryan Chesley",
        salary2025: "$923,333",
      },
      {
        player: "Leon Muggli",
        salary2025: "$908,333",
      },
      {
        player: "Cam Allen",
        salary2025: "$855,000",
      },
      {
        player: "David Gucciardi",
        salary2025: "$855,000",
      },
      {
        player: "Louie Belpedio",
        salary2025: "$775,000",
      },
      {
        player: "Corey Schueneman",
        salary2025: "$775,000",
      },
      {
        player: "Clay Stevenson",
        salary2025: "$775,000",
      },
      {
        player: "Garin Bjorklund",
        salary2025: "$775,000",
      },
    ],
  },
  {
    winnipeg_jets: [
      {
        player: "Jacob Bryson",
        salary2025: "$900,000",
      },

      {
        player: "Mark Scheifele",
        salary2025: "$8,500,000",
      },
      {
        player: "Gabriel Vilardi",
        salary2025: "$7,500,000",
      },
      {
        player: "Kyle Connor",
        salary2025: "$7,142,857",
      },
      {
        player: "Nino Niederreiter",
        salary2025: "$4,000,000",
      },
      {
        player: "Alex Iafallo",
        salary2025: "$3,666,667",
      },
      {
        player: "Cole Perfetti",
        salary2025: "$3,250,000",
      },
      {
        player: "Adam Lowry",
        salary2025: "$3,250,000",
      },
      {
        player: "Gustav Nyquist",
        salary2025: "$3,250,000",
      },
      {
        player: "Vladislav Namestnikov",
        salary2025: "$3,000,000",
      },
      {
        player: "Jonathan Toews",
        salary2025: "$2,000,000",
      },
      {
        player: "Morgan Barron",
        salary2025: "$1,850,000",
      },
      {
        player: "Cole Koepke",
        salary2025: "$1,000,000",
      },
      {
        player: "Tanner Pearson",
        salary2025: "$1,000,000",
      },
      {
        player: "Danil Zhilkin",
        salary2025: "$803,333",
      },
      {
        player: "Neal Pionk",
        salary2025: "$7,000,000",
      },
      {
        player: "Josh Morrissey",
        salary2025: "$6,250,000",
      },
      {
        player: "Dylan Samberg",
        salary2025: "$5,750,000",
      },
      {
        player: "Dylan DeMelo",
        salary2025: "$4,900,000",
      },
      {
        player: "Luke Schenn",
        salary2025: "$2,750,000",
      },
      {
        player: "Colin Miller",
        salary2025: "$1,500,000",
      },
      {
        player: "Logan Stanley",
        salary2025: "$1,250,000",
      },
      {
        player: "Haydn Fleury",
        salary2025: "$950,000",
      },
      {
        player: "Elias Salomonsson",
        salary2025: "$815,000",
      },
      {
        player: "Isaak Phillips",
        salary2025: "$812,500",
      },
      {
        player: "Connor Hellebuyck",
        salary2025: "$8,500,000",
      },
      {
        player: "Eric Comrie",
        salary2025: "$825,000",
      },
      {
        player: "Nate Schmidt",
        salary2025: "$1,616,667",
      },
      {
        player: "Brayden Yager",
        salary2025: "$918,333",
      },
      {
        player: "Jacob Julien",
        salary2025: "$895,000",
      },
      {
        player: "Colby Barlow",
        salary2025: "$886,667",
      },
      {
        player: "Brad Lambert",
        salary2025: "$886,667",
      },
      {
        player: "Nikita Chibrikov",
        salary2025: "$875,833",
      },
      {
        player: "Kieron Walton",
        salary2025: "$858,333",
      },
      {
        player: "Kevin He",
        salary2025: "$840,000",
      },
      {
        player: "David Gustafsson",
        salary2025: "$835,000",
      },
      {
        player: "Fabian Wagner",
        salary2025: "$830,556",
      },
      {
        player: "Parker Ford",
        salary2025: "$812,500",
      },
      {
        player: "Mason Shaw",
        salary2025: "$775,000",
      },
      {
        player: "Phillip Di Giuseppe",
        salary2025: "$775,000",
      },
      {
        player: "Jaret Anderson-Dolan",
        salary2025: "$775,000",
      },
      {
        player: "Samuel Fagemo",
        salary2025: "$775,000",
      },
      {
        player: "Walker Duehr",
        salary2025: "$775,000",
      },
      {
        player: "Alfons Freij",
        salary2025: "$905,833",
      },
      {
        player: "Ville Heinola",
        salary2025: "$800,000",
      },
      {
        player: "Tyrel Bauer",
        salary2025: "$775,000",
      },
      {
        player: "Kale Clague",
        salary2025: "$775,000",
      },
      {
        player: "Thomas Milic",
        salary2025: "$841,667",
      },
      {
        player: "Domenic DiVincentiis",
        salary2025: "$830,556",
      },
      {
        player: "Isaac Poulter",
        salary2025: "$775,000",
      },
    ],
  },
];

export default salary;
